function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

/**
 * @public
 */
var SkygearErrorNames = {
  BadRequest: "BadRequest",
  Invalid: "Invalid",
  Unauthorized: "Unauthorized",
  Forbidden: "Forbidden",
  NotFound: "NotFound",
  AlreadyExists: "AlreadyExists",
  TooManyRequest: "TooManyRequest",
  InternalError: "InternalError",
  ServiceUnavailable: "ServiceUnavailable"
};
/**
 * @public
 */

/**
 * Skygear API error.
 *
 * @remarks
 * All Skygear APIs (e.g. Auth, Asset) functions would throw errors of this
 * type if server returns failure.
 *
 * @public
 */
var SkygearError =
/*#__PURE__*/
function (_Error) {
  _inherits(SkygearError, _Error);

  /**
   * Error name.
   *
   * @remarks
   * See {@link SkygearErrorNames} for possible values.
   * New error names may be added in future.
   */

  /**
   * Error message.
   *
   * @remarks
   * Error messages are provided for convenience, and not stable APIs;
   * Consumers should use {@link SkygearError.name} or
   * {@link SkygearError.reason} to distinguish between different errors.
   */

  /**
   * Error reason.
   */

  /**
   * Additional error information.
   */
  function SkygearError(message, name, reason, info) {
    var _this;

    _classCallCheck(this, SkygearError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SkygearError).call(this, message));
    _this.name = name;
    _this.reason = reason;
    _this.info = info;
    return _this;
  }

  return SkygearError;
}(_wrapNativeSuper(Error));
/**
 * @public
 */

function decodeError(err) {
  // Construct SkygearError if it looks like one.
  if (err != null && !(err instanceof Error) && typeof err.name === "string" && typeof err.reason === "string" && typeof err.message === "string") {
    return new SkygearError(err.message, err.name, err.reason, err.info);
  } // If it is an Error, just return it.


  if (err instanceof Error) {
    return err;
  } // If it has message, construct an Error from the message.


  if (err != null && typeof err.message === "string") {
    return new Error(err.message);
  } // If it can be turned into string, use it as message.


  if (err != null && typeof err.toString === "function") {
    return new Error(err.toString());
  } // Otherwise cast it to string and use it as message.


  return new Error(String(err));
}
/**
 * @internal
 */

function _extractAuthenticationSession(e) {
  if (e instanceof SkygearError && e.reason === "AuthenticationSession" && e.info != null) {
    var _ref = e.info,
        token = _ref.token,
        step = _ref.step;
    return {
      token: token,
      step: step
    };
  }

  return null;
}
/**
 * Check if the provided error indicates Multi-Factor-Authentication is
 * required during authentication.
 *
 * @remarks
 * The error may be thrown when attempting to login/signup if configured.
 *
 * @public
 */

function isMFARequiredError(e) {
  var authenticationSession = _extractAuthenticationSession(e);

  return authenticationSession != null && authenticationSession.step === "mfa";
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var regenerator = runtime_1;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/**
 * @public
 */
function encodeQueryComponent(s) {
  return encodeURIComponent(s).replace(/%20/g, "+");
}
/**
 * @public
 */

function encodeQuery(query) {
  if (query == null || query.length <= 0) {
    return "";
  }

  var output = "?";

  for (var i = 0; i < query.length; ++i) {
    var key = encodeQueryComponent(query[i][0]);
    var value = encodeQueryComponent(query[i][1]);

    if (key === "" && value === "") {
      continue;
    }

    if (output !== "?") {
      output += "&";
    }

    output += key;

    if (value !== "") {
      output += "=";
      output += value;
    }
  }

  return output;
}

/**
 * @public
 */
function decodeAuthResponse(r) {
  var user = r.user,
      identity = r.identity,
      access_token = r.access_token,
      refresh_token = r.refresh_token,
      session_id = r.session_id,
      mfa_bearer_token = r.mfa_bearer_token;
  var response = {
    user: decodeUser(user)
  };

  if (identity) {
    response.identity = decodeIdentity(identity);
  }

  if (access_token) {
    response.accessToken = access_token;
  }

  if (refresh_token) {
    response.refreshToken = refresh_token;
  }

  if (session_id) {
    response.sessionID = session_id;
  }

  if (mfa_bearer_token) {
    response.mfaBearerToken = mfa_bearer_token;
  }

  return response;
}
/**
 * @public
 */

function decodeUser(u) {
  var id = u.id;
  var createdAt = new Date(u.created_at);
  var lastLoginAt = new Date(u.last_login_at);
  var isVerified = u.is_verified;
  var isManuallyVerified = u.is_manually_verified;
  var isDisabled = u.is_disabled;
  var metadata = u.metadata;
  return {
    id: id,
    createdAt: createdAt,
    lastLoginAt: lastLoginAt,
    isManuallyVerified: isManuallyVerified,
    isVerified: isVerified,
    isDisabled: isDisabled,
    metadata: metadata
  };
}
/**
 * @public
 */

function decodeIdentity(i) {
  var id = i.id;
  var type = i.type;

  switch (type) {
    case "password":
      return {
        id: id,
        type: "password",
        loginIDKey: i.login_id_key,
        loginID: i.login_id,
        claims: i.claims
      };

    case "oauth":
      return {
        id: id,
        type: "oauth",
        providerType: i.provider_type,
        providerUserID: i.provider_user_id,
        rawProfile: i.raw_profile,
        claims: i.claims
      };

    case "custom_token":
      return {
        id: id,
        type: "custom_token",
        providerUserID: i.provider_user_id,
        rawProfile: i.raw_profile,
        claims: i.claims
      };

    default:
      throw new Error("unknown identity type: " + type);
  }
}
/**
 * @public
 */

function decodeSession(s) {
  var id = s.id;
  var identityID = s.identity_id;
  var createdAt = new Date(s.created_at);
  var lastAccessedAt = new Date(s.last_accessed_at);
  var createdByIP = s.created_by_ip;
  var lastAccessedByIP = s.last_accessed_by_ip;
  var userAgent = decodeSessionUserAgent(s.user_agent);
  var name = s.name;
  var data = s.data;
  return {
    id: id,
    identityID: identityID,
    createdAt: createdAt,
    lastAccessedAt: lastAccessedAt,
    createdByIP: createdByIP,
    lastAccessedByIP: lastAccessedByIP,
    userAgent: userAgent,
    name: name,
    data: data
  };
}
/**
 * @public
 */

function decodeAuthenticator(a) {
  var id = a.id;
  var type = a.type;
  var createdAt = new Date(a.created_at);
  var activatedAt = new Date(a.activated_at);

  switch (type) {
    case "totp":
      return {
        id: id,
        type: type,
        createdAt: createdAt,
        activatedAt: activatedAt,
        displayName: a.display_name
      };

    case "oob":
      {
        var channel = a.channel;

        switch (channel) {
          case "sms":
            return {
              id: id,
              type: type,
              createdAt: createdAt,
              activatedAt: activatedAt,
              channel: channel,
              maskedPhone: a.masked_phone
            };

          case "email":
            return {
              id: id,
              type: type,
              createdAt: createdAt,
              activatedAt: activatedAt,
              channel: channel,
              maskedEmail: a.masked_email
            };

          default:
            throw new Error("unknown authenticator channel: " + channel);
        }
      }

    default:
      throw new Error("unknown authenticator type: " + type);
  }
}

function decodeSessionUserAgent(ua) {
  return {
    raw: ua.raw,
    name: ua.name,
    version: ua.version,
    os: ua.os,
    osVersion: ua.os_version,
    deviceName: ua.device_name,
    deviceModel: ua.device_model
  };
}
/**
 * @internal
 */


function _decodeExtraSessionInfoOptions(o) {
  var opts = {};

  if (o.device_name !== undefined) {
    opts.deviceName = o.device_name;
  }

  return opts;
}
/**
 * @public
 */

function encodeUser(u) {
  var created_at = u.createdAt.toISOString();
  var last_login_at = u.lastLoginAt.toISOString();
  return {
    id: u.id,
    created_at: created_at,
    last_login_at: last_login_at,
    is_manually_verified: u.isManuallyVerified,
    is_verified: u.isVerified,
    is_disabled: u.isDisabled,
    metadata: u.metadata
  };
}
/**
 * @public
 */

function encodeIdentity(i) {
  switch (i.type) {
    case "password":
      return {
        id: i.id,
        type: "password",
        login_id_key: i.loginIDKey,
        login_id: i.loginID,
        claims: i.claims
      };

    case "oauth":
      return {
        id: i.id,
        type: "oauth",
        provider_type: i.providerType,
        provider_user_id: i.providerUserID,
        raw_profile: i.rawProfile,
        claims: i.claims
      };

    case "custom_token":
      return {
        id: i.id,
        type: "custom_token",
        provider_user_id: i.providerUserID,
        raw_profile: i.rawProfile,
        claims: i.claims
      };

    default:
      throw new Error("unknown identity type: ");
  }
}
/**
 * @internal
 */

function _encodeExtraSessionInfoOptions(o) {
  return {
    device_name: o.deviceName
  };
}

// https://developer.mozilla.org/en-US/docs/Web/API/TextEncoder#Polyfill

/**
 * @internal
 */
function _encodeUTF8(input) {
  var resArr = new Array(input.length * 2);
  var resPos = -1;

  for (var i = 0; i !== input.length; i++) {
    var point = input.charCodeAt(i);

    if (point >= 0xd800 && point <= 0xdbff) {
      if (i === input.length - 1) {
        resArr[resPos += 1] = 0xef
        /*0b11101111*/
        ;
        resArr[resPos += 1] = 0xbf
        /*0b10111111*/
        ;
        resArr[resPos += 1] = 0xbd
        /*0b10111101*/
        ;
        break;
      }

      var nextcode = input.charCodeAt(i + 1);

      if (nextcode >= 0xdc00 && nextcode <= 0xdfff) {
        point = (point - 0xd800) * 0x400 + nextcode - 0xdc00 + 0x10000;
        i += 1;

        if (point > 0xffff) {
          resArr[resPos += 1] = 0x1e
          /*0b11110*/
          << 3 | point >>> 18;
          resArr[resPos += 1] = 0x2
          /*0b10*/
          << 6 | point >>> 12 & 0x3f
          /*0b00111111*/
          ;
          resArr[resPos += 1] = 0x2
          /*0b10*/
          << 6 | point >>> 6 & 0x3f
          /*0b00111111*/
          ;
          resArr[resPos += 1] = 0x2
          /*0b10*/
          << 6 | point & 0x3f
          /*0b00111111*/
          ;
          continue;
        }
      } else {
        resArr[resPos += 1] = 0xef
        /*0b11101111*/
        ;
        resArr[resPos += 1] = 0xbf
        /*0b10111111*/
        ;
        resArr[resPos += 1] = 0xbd
        /*0b10111101*/
        ;
        continue;
      }
    }

    if (point <= 0x007f) {
      resArr[resPos += 1] = 0x0
      /*0b0*/
      << 7 | point;
    } else if (point <= 0x07ff) {
      resArr[resPos += 1] = 0x6
      /*0b110*/
      << 5 | point >>> 6;
      resArr[resPos += 1] = 0x2
      /*0b10*/
      << 6 | point & 0x3f
      /*0b00111111*/
      ;
    } else {
      resArr[resPos += 1] = 0xe
      /*0b1110*/
      << 4 | point >>> 12;
      resArr[resPos += 1] = 0x2
      /*0b10*/
      << 6 | point >>> 6 & 0x3f
      /*0b00111111*/
      ;
      resArr[resPos += 1] = 0x2
      /*0b10*/
      << 6 | point & 0x3f
      /*0b00111111*/
      ;
    }
  }

  resArr.length = resPos + 1;
  return resArr;
}

// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
function uint6ToB64(nUint6) {
  return nUint6 < 26 ? nUint6 + 65 : nUint6 < 52 ? nUint6 + 71 : nUint6 < 62 ? nUint6 - 4 : nUint6 === 62 ? 43 : nUint6 === 63 ? 47 : 65;
}

function uint6ToB64URL(nUint6) {
  return nUint6 < 26 ? nUint6 + 65 : nUint6 < 52 ? nUint6 + 71 : nUint6 < 62 ? nUint6 - 4 : nUint6 === 62 ? 45 : nUint6 === 63 ? 95 : 65;
}

function base64EncArr(aBytes) {
  var eqLen = (3 - aBytes.length % 3) % 3;
  var sB64Enc = "";
  var nUint24 = 0;

  for (var nIdx = 0; nIdx < aBytes.length; nIdx++) {
    var nMod3 = nIdx % 3;
    nUint24 |= aBytes[nIdx] << (16 >>> nMod3 & 24);

    if (nMod3 === 2 || aBytes.length - nIdx === 1) {
      sB64Enc += String.fromCharCode(uint6ToB64(nUint24 >>> 18 & 63), uint6ToB64(nUint24 >>> 12 & 63), uint6ToB64(nUint24 >>> 6 & 63), uint6ToB64(nUint24 & 63));
      nUint24 = 0;
    }
  }

  return eqLen === 0 ? sB64Enc : sB64Enc.substring(0, sB64Enc.length - eqLen) + (eqLen === 1 ? "=" : "==");
}

function base64URLEncArr(aBytes) {
  var eqLen = (3 - aBytes.length % 3) % 3;
  var sB64Enc = "";
  var nUint24 = 0;

  for (var nIdx = 0; nIdx < aBytes.length; nIdx++) {
    var nMod3 = nIdx % 3;
    nUint24 |= aBytes[nIdx] << (16 >>> nMod3 & 24);

    if (nMod3 === 2 || aBytes.length - nIdx === 1) {
      sB64Enc += String.fromCharCode(uint6ToB64URL(nUint24 >>> 18 & 63), uint6ToB64URL(nUint24 >>> 12 & 63), uint6ToB64URL(nUint24 >>> 6 & 63), uint6ToB64URL(nUint24 & 63));
      nUint24 = 0;
    }
  }

  return eqLen === 0 ? sB64Enc : sB64Enc.substring(0, sB64Enc.length - eqLen);
}
/**
 * @internal
 */


function _encodeBase64FromString(input) {
  var bytes = _encodeUTF8(input);

  return base64EncArr(bytes);
}
/**
 * @internal
 */

function _encodeBase64URLFromByteArray(bytes) {
  return base64URLEncArr(bytes);
}
/**
 * @internal
 */

function _windowAtob(string) {
  // This is borrowed from
  // https://github.com/MaxArt2501/base64-js/blob/master/base64.js
  var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="; // Regular expression to check formal correctness of base64 encoded strings
  // eslint-disable-next-line no-useless-escape

  var b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/; // atob can work with strings with whitespaces, even inside the encoded part,
  // but only \t, \n, \f, \r and ' ', which can be stripped.

  string = String(string).replace(/[\t\n\f\r ]+/g, "");
  if (!b64re.test(string)) throw new TypeError("Failed to execute 'atob' on 'Window': The string to be decoded is not correctly encoded."); // Adding the padding if missing, for semplicity

  string += "==".slice(2 - (string.length & 3));
  var bitmap,
      result = "",
      r1,
      r2,
      i = 0;

  for (; i < string.length;) {
    bitmap = b64.indexOf(string.charAt(i++)) << 18 | b64.indexOf(string.charAt(i++)) << 12 | (r1 = b64.indexOf(string.charAt(i++))) << 6 | (r2 = b64.indexOf(string.charAt(i++)));
    result += r1 === 64 ? String.fromCharCode(bitmap >> 16 & 255) : r2 === 64 ? String.fromCharCode(bitmap >> 16 & 255, bitmap >> 8 & 255) : String.fromCharCode(bitmap >> 16 & 255, bitmap >> 8 & 255, bitmap & 255);
  }

  return result;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * @internal
 */

function _removeTrailingSlash(s) {
  return s.replace(/\/+$/g, "");
}

function shouldRefreshToken(r) {
  var h = r.headers.get("x-skygear-try-refresh-token");
  return h === "true";
}

function extractSingleKeyValue(o, errorMessage) {
  var keys = Object.keys(o);

  if (keys.length !== 1) {
    throw new Error(errorMessage);
  }

  return [keys[0], o[keys[0]]];
}
/**
 * @public
 */


var BaseAPIClient =
/*#__PURE__*/
function () {
  /**
   * @internal
   */

  /**
   * @internal
   */
  function BaseAPIClient() {
    _classCallCheck(this, BaseAPIClient);

    this.apiKey = "";
    this.endpoint = "";
    this._accessToken = null;
    this._authenticationSession = null;
  }

  _createClass(BaseAPIClient, [{
    key: "prepareHeaders",
    value: function () {
      var _prepareHeaders = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee() {
        var headers, extraSessionInfo;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                headers = {
                  "x-skygear-api-key": this.apiKey
                };

                if (this._accessToken) {
                  headers["authorization"] = "bearer ".concat(this._accessToken);
                }

                if (this.userAgent !== undefined) {
                  headers["user-agent"] = this.userAgent;
                }

                if (!this.getExtraSessionInfo) {
                  _context.next = 8;
                  break;
                }

                _context.next = 6;
                return this.getExtraSessionInfo();

              case 6:
                extraSessionInfo = _context.sent;

                if (extraSessionInfo) {
                  headers["x-skygear-extra-info"] = _encodeBase64FromString(JSON.stringify(extraSessionInfo));
                }

              case 8:
                return _context.abrupt("return", headers);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function prepareHeaders() {
        return _prepareHeaders.apply(this, arguments);
      }

      return prepareHeaders;
    }()
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee2(input, init) {
        var options,
            _options$autoRefreshT,
            autoRefreshToken,
            url,
            request,
            headers,
            _i2,
            _Object$keys2,
            _key,
            response,
            tokenRefreshed,
            retryRequest,
            _headers,
            _i4,
            _Object$keys4,
            _key2,
            _args2 = arguments;

        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};

                if (!(this.fetchFunction == null)) {
                  _context2.next = 3;
                  break;
                }

                throw new Error("missing fetchFunction in api client");

              case 3:
                if (!(this.requestClass == null)) {
                  _context2.next = 5;
                  break;
                }

                throw new Error("missing requestClass in api client");

              case 5:
                _options$autoRefreshT = options.autoRefreshToken, autoRefreshToken = _options$autoRefreshT === void 0 ? !!this.refreshTokenFunction : _options$autoRefreshT;

                if (!(typeof input !== "string")) {
                  _context2.next = 8;
                  break;
                }

                throw new Error("only string path is allowed for fetch input");

              case 8:
                url = this.endpoint + "/" + input.replace(/^\//, "");
                request = new this.requestClass(url, init);
                _context2.next = 12;
                return this.prepareHeaders();

              case 12:
                headers = _context2.sent;

                for (_i2 = 0, _Object$keys2 = Object.keys(headers); _i2 < _Object$keys2.length; _i2++) {
                  _key = _Object$keys2[_i2];
                  request.headers.set(_key, headers[_key]);
                }

                _context2.next = 16;
                return this.fetchFunction(request.clone());

              case 16:
                response = _context2.sent;

                if (!(shouldRefreshToken(response) && autoRefreshToken)) {
                  _context2.next = 32;
                  break;
                }

                if (this.refreshTokenFunction) {
                  _context2.next = 20;
                  break;
                }

                throw new Error("missing refreshTokenFunction in api client");

              case 20:
                _context2.next = 22;
                return this.refreshTokenFunction();

              case 22:
                tokenRefreshed = _context2.sent;

                if (!tokenRefreshed) {
                  _context2.next = 32;
                  break;
                }

                retryRequest = request.clone(); // use latest access token

                _context2.next = 27;
                return this.prepareHeaders();

              case 27:
                _headers = _context2.sent;

                for (_i4 = 0, _Object$keys4 = Object.keys(_headers); _i4 < _Object$keys4.length; _i4++) {
                  _key2 = _Object$keys4[_i4];
                  retryRequest.headers.set(_key2, _headers[_key2]);
                }

                _context2.next = 31;
                return this.fetchFunction(retryRequest);

              case 31:
                response = _context2.sent;

              case 32:
                return _context2.abrupt("return", response);

              case 33:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee3(method, path) {
        var options,
            json,
            query,
            autoRefreshToken,
            p,
            headers,
            response,
            jsonBody,
            _args3 = arguments;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
                json = options.json, query = options.query, autoRefreshToken = options.autoRefreshToken;
                p = path;

                if (query != null) {
                  p += encodeQuery(query);
                }

                headers = {};

                if (json != null) {
                  headers["content-type"] = "application/json";
                }

                _context3.next = 8;
                return this.fetch(p, {
                  method: method,
                  headers: headers,
                  mode: "cors",
                  credentials: "include",
                  body: json && JSON.stringify(json)
                }, {
                  autoRefreshToken: autoRefreshToken
                });

              case 8:
                response = _context3.sent;
                _context3.prev = 9;
                _context3.next = 12;
                return response.json();

              case 12:
                jsonBody = _context3.sent;
                _context3.next = 22;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](9);

                if (!(response.status < 200 || response.status >= 300)) {
                  _context3.next = 21;
                  break;
                }

                throw new SkygearError("unexpected status code", "InternalError", "UnexpectedError", {
                  status_code: response.status
                });

              case 21:
                throw new SkygearError("failed to decode response JSON", "InternalError", "UnexpectedError");

              case 22:
                if (!jsonBody["result"]) {
                  _context3.next = 26;
                  break;
                }

                return _context3.abrupt("return", jsonBody["result"]);

              case 26:
                if (!jsonBody["error"]) {
                  _context3.next = 28;
                  break;
                }

                throw decodeError(jsonBody["error"]);

              case 28:
                throw decodeError();

              case 29:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[9, 15]]);
      }));

      function request(_x3, _x4) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
  }, {
    key: "post",
    value: function () {
      var _post = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee4(path, options) {
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.request("POST", path, options));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function post(_x5, _x6) {
        return _post.apply(this, arguments);
      }

      return post;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee5(path, options) {
        return regenerator.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", this.request("GET", path, options));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function get(_x7, _x8) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "del",
    value: function () {
      var _del = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee6(path, options) {
        return regenerator.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.request("DELETE", path, options));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function del(_x9, _x10) {
        return _del.apply(this, arguments);
      }

      return del;
    }()
  }, {
    key: "postAndReturnAuthResponse",
    value: function () {
      var _postAndReturnAuthResponse = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee7(path, options) {
        var response;
        return regenerator.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.post(path, options);

              case 2:
                response = _context7.sent;
                return _context7.abrupt("return", decodeAuthResponse(response));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function postAndReturnAuthResponse(_x11, _x12) {
        return _postAndReturnAuthResponse.apply(this, arguments);
      }

      return postAndReturnAuthResponse;
    }()
    /**
     * @internal
     */

  }, {
    key: "makePayloadWithAuthenticationSessionToken",
    value: function makePayloadWithAuthenticationSessionToken(payload) {
      if (this._authenticationSession != null) {
        var newPayload = _objectSpread({}, payload, {
          authn_session_token: this._authenticationSession.token
        });

        return newPayload;
      }

      return payload;
    }
  }, {
    key: "signup",
    value: function () {
      var _signup = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee8(loginIDs, password, options) {
        var ids, _i6, obj, _i8, _Object$keys6, _key3, value, _i10, _Object$keys8, _key4, _value, payload;

        return regenerator.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                ids = [];

                if (Array.isArray(loginIDs)) {
                  for (_i6 = 0; _i6 < loginIDs.length; _i6++) {
                    obj = loginIDs[_i6];

                    for (_i8 = 0, _Object$keys6 = Object.keys(obj); _i8 < _Object$keys6.length; _i8++) {
                      _key3 = _Object$keys6[_i8];
                      value = obj[_key3];
                      ids.push({
                        key: _key3,
                        value: value
                      });
                    }
                  }
                } else {
                  for (_i10 = 0, _Object$keys8 = Object.keys(loginIDs); _i10 < _Object$keys8.length; _i10++) {
                    _key4 = _Object$keys8[_i10];
                    _value = loginIDs[_key4];
                    ids.push({
                      key: _key4,
                      value: _value
                    });
                  }
                }

                payload = {
                  password: password,
                  login_ids: ids,
                  metadata: options && options.metadata
                };
                return _context8.abrupt("return", this.postAndReturnAuthResponse("/_auth/signup", {
                  json: payload
                }));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function signup(_x13, _x14, _x15) {
        return _signup.apply(this, arguments);
      }

      return signup;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee9(loginID, password, options) {
        var payload;
        return regenerator.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                payload = {
                  password: password,
                  login_id: loginID,
                  login_id_key: options && options.loginIDKey
                };
                return _context9.abrupt("return", this.postAndReturnAuthResponse("/_auth/login", {
                  json: payload
                }));

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function login(_x16, _x17, _x18) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee10() {
        return regenerator.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.post("/_auth/logout", {
                  json: {}
                });

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee11(refreshToken) {
        var payload, response;
        return regenerator.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                payload = {
                  refresh_token: refreshToken
                };
                _context11.next = 3;
                return this.post("/_auth/refresh", {
                  json: payload,
                  autoRefreshToken: false
                });

              case 3:
                response = _context11.sent;
                return _context11.abrupt("return", response.access_token);

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function refresh(_x19) {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "me",
    value: function () {
      var _me = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee12() {
        return regenerator.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt("return", this.postAndReturnAuthResponse("/_auth/me", {
                  json: {}
                }));

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function me() {
        return _me.apply(this, arguments);
      }

      return me;
    }()
  }, {
    key: "changePassword",
    value: function () {
      var _changePassword = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee13(newPassword, oldPassword) {
        var payload;
        return regenerator.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                payload = {
                  password: newPassword,
                  old_password: oldPassword
                };
                return _context13.abrupt("return", this.postAndReturnAuthResponse("/_auth/change_password", {
                  json: payload
                }));

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function changePassword(_x20, _x21) {
        return _changePassword.apply(this, arguments);
      }

      return changePassword;
    }()
  }, {
    key: "updateMetadata",
    value: function () {
      var _updateMetadata = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee14(metadata) {
        var payload;
        return regenerator.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                payload = {
                  metadata: metadata
                };
                return _context14.abrupt("return", this.postAndReturnAuthResponse("/_auth/update_metadata", {
                  json: payload
                }));

              case 2:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function updateMetadata(_x22) {
        return _updateMetadata.apply(this, arguments);
      }

      return updateMetadata;
    }()
  }, {
    key: "requestForgotPasswordEmail",
    value: function () {
      var _requestForgotPasswordEmail = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee15(email) {
        var payload;
        return regenerator.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                payload = {
                  email: email
                };
                _context15.next = 3;
                return this.post("/_auth/forgot_password", {
                  json: payload
                });

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function requestForgotPasswordEmail(_x23) {
        return _requestForgotPasswordEmail.apply(this, arguments);
      }

      return requestForgotPasswordEmail;
    }()
  }, {
    key: "resetPassword",
    value: function () {
      var _resetPassword = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee16(form) {
        var payload;
        return regenerator.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                payload = {
                  user_id: form.userID,
                  code: form.code,
                  expire_at: form.expireAt,
                  new_password: form.newPassword
                };
                _context16.next = 3;
                return this.post("/_auth/forgot_password/reset_password", {
                  json: payload
                });

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function resetPassword(_x24) {
        return _resetPassword.apply(this, arguments);
      }

      return resetPassword;
    }()
  }, {
    key: "requestEmailVerification",
    value: function () {
      var _requestEmailVerification = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee17(email) {
        var payload;
        return regenerator.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                payload = {
                  login_id_type: "email",
                  login_id: email
                };
                _context17.next = 3;
                return this.post("/_auth/verify_request", {
                  json: payload
                });

              case 3:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function requestEmailVerification(_x25) {
        return _requestEmailVerification.apply(this, arguments);
      }

      return requestEmailVerification;
    }()
  }, {
    key: "requestPhoneVerification",
    value: function () {
      var _requestPhoneVerification = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee18(phone) {
        var payload;
        return regenerator.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                payload = {
                  login_id_type: "phone",
                  login_id: phone
                };
                _context18.next = 3;
                return this.post("/_auth/verify_request", {
                  json: payload
                });

              case 3:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function requestPhoneVerification(_x26) {
        return _requestPhoneVerification.apply(this, arguments);
      }

      return requestPhoneVerification;
    }()
  }, {
    key: "verifyWithCode",
    value: function () {
      var _verifyWithCode = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee19(code) {
        var payload;
        return regenerator.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                payload = {
                  code: code
                };
                _context19.next = 3;
                return this.post("/_auth/verify_code", {
                  json: payload
                });

              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function verifyWithCode(_x27) {
        return _verifyWithCode.apply(this, arguments);
      }

      return verifyWithCode;
    }()
  }, {
    key: "loginWithCustomToken",
    value: function () {
      var _loginWithCustomToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee20(token, options) {
        var payload;
        return regenerator.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                payload = {
                  token: token,
                  on_user_duplicate: options && options.onUserDuplicate
                };
                return _context20.abrupt("return", this.postAndReturnAuthResponse("/_auth/sso/custom_token/login", {
                  json: payload
                }));

              case 2:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function loginWithCustomToken(_x28, _x29) {
        return _loginWithCustomToken.apply(this, arguments);
      }

      return loginWithCustomToken;
    }()
  }, {
    key: "oauthAuthorizationURL",
    value: function () {
      var _oauthAuthorizationURL = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee21(options) {
        var providerID, uxMode, onUserDuplicate, codeChallenge, action, encoded, path, callbackURL, payload;
        return regenerator.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                providerID = options.providerID, uxMode = options.uxMode, onUserDuplicate = options.onUserDuplicate, codeChallenge = options.codeChallenge, action = options.action;
                encoded = encodeURIComponent(providerID);
                path = "";
                _context21.t0 = action;
                _context21.next = _context21.t0 === "login" ? 6 : _context21.t0 === "link" ? 8 : 10;
                break;

              case 6:
                path = "/_auth/sso/".concat(encoded, "/login_auth_url");
                return _context21.abrupt("break", 11);

              case 8:
                path = "/_auth/sso/".concat(encoded, "/link_auth_url");
                return _context21.abrupt("break", 11);

              case 10:
                throw new Error("unreachable");

              case 11:
                callbackURL = "callbackURL" in options && options.callbackURL || typeof window !== "undefined" && window.location.href;

                if (callbackURL) {
                  _context21.next = 14;
                  break;
                }

                throw new Error("callbackURL is required");

              case 14:
                payload = {
                  callback_url: callbackURL,
                  ux_mode: uxMode,
                  on_user_duplicate: onUserDuplicate,
                  code_challenge: codeChallenge
                };
                return _context21.abrupt("return", this.post(path, {
                  json: payload
                }));

              case 16:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function oauthAuthorizationURL(_x30) {
        return _oauthAuthorizationURL.apply(this, arguments);
      }

      return oauthAuthorizationURL;
    }()
  }, {
    key: "oauthHandler",
    value: function () {
      var _oauthHandler = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee22(options) {
        var providerID, code, scope, state, encoded, path;
        return regenerator.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                providerID = options.providerID, code = options.code, scope = options.scope, state = options.state;
                encoded = encodeURIComponent(providerID);
                path = "/_auth/sso/".concat(encoded, "/auth_handler");
                return _context22.abrupt("return", this.get(path, {
                  query: [["code", code], ["scope", scope], ["state", state]]
                }));

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function oauthHandler(_x31) {
        return _oauthHandler.apply(this, arguments);
      }

      return oauthHandler;
    }()
  }, {
    key: "getOAuthResult",
    value: function () {
      var _getOAuthResult = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee23(options) {
        var authorizationCode, codeVerifier, payload;
        return regenerator.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                authorizationCode = options.authorizationCode, codeVerifier = options.codeVerifier;
                payload = {
                  authorization_code: authorizationCode,
                  code_verifier: codeVerifier
                };
                return _context23.abrupt("return", this.postAndReturnAuthResponse("/_auth/sso/auth_result", {
                  json: payload
                }));

              case 3:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function getOAuthResult(_x32) {
        return _getOAuthResult.apply(this, arguments);
      }

      return getOAuthResult;
    }()
  }, {
    key: "deleteOAuthProvider",
    value: function () {
      var _deleteOAuthProvider = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee24(providerID) {
        var encoded;
        return regenerator.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                encoded = encodeURIComponent(providerID);
                _context24.next = 3;
                return this.post("/_auth/sso/".concat(encoded, "/unlink"), {
                  json: {}
                });

              case 3:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function deleteOAuthProvider(_x33) {
        return _deleteOAuthProvider.apply(this, arguments);
      }

      return deleteOAuthProvider;
    }()
  }, {
    key: "loginOAuthProviderWithAccessToken",
    value: function () {
      var _loginOAuthProviderWithAccessToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee25(providerID, accessToken, options) {
        var encoded, payload;
        return regenerator.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                encoded = encodeURIComponent(providerID);
                payload = {
                  access_token: accessToken,
                  on_user_duplicate: options && options.onUserDuplicate
                };
                return _context25.abrupt("return", this.postAndReturnAuthResponse("/_auth/sso/".concat(encoded, "/login"), {
                  json: payload
                }));

              case 3:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function loginOAuthProviderWithAccessToken(_x34, _x35, _x36) {
        return _loginOAuthProviderWithAccessToken.apply(this, arguments);
      }

      return loginOAuthProviderWithAccessToken;
    }()
  }, {
    key: "linkOAuthProviderWithAccessToken",
    value: function () {
      var _linkOAuthProviderWithAccessToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee26(providerID, accessToken) {
        var encoded, payload;
        return regenerator.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                encoded = encodeURIComponent(providerID);
                payload = {
                  access_token: accessToken
                };
                return _context26.abrupt("return", this.postAndReturnAuthResponse("/_auth/sso/".concat(encoded, "/link"), {
                  json: payload
                }));

              case 3:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function linkOAuthProviderWithAccessToken(_x37, _x38) {
        return _linkOAuthProviderWithAccessToken.apply(this, arguments);
      }

      return linkOAuthProviderWithAccessToken;
    }()
  }, {
    key: "listSessions",
    value: function () {
      var _listSessions = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee27() {
        var response;
        return regenerator.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return this.post("/_auth/session/list", {
                  json: {}
                });

              case 2:
                response = _context27.sent;
                return _context27.abrupt("return", response.sessions.map(decodeSession));

              case 4:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function listSessions() {
        return _listSessions.apply(this, arguments);
      }

      return listSessions;
    }()
  }, {
    key: "getSession",
    value: function () {
      var _getSession = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee28(id) {
        var payload, response;
        return regenerator.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                payload = {
                  session_id: id
                };
                _context28.next = 3;
                return this.post("/_auth/session/get", {
                  json: payload
                });

              case 3:
                response = _context28.sent;
                return _context28.abrupt("return", decodeSession(response.session));

              case 5:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function getSession(_x39) {
        return _getSession.apply(this, arguments);
      }

      return getSession;
    }()
  }, {
    key: "revokeSession",
    value: function () {
      var _revokeSession = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee29(id) {
        var payload;
        return regenerator.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                payload = {
                  session_id: id
                };
                return _context29.abrupt("return", this.post("/_auth/session/revoke", {
                  json: payload
                }));

              case 2:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function revokeSession(_x40) {
        return _revokeSession.apply(this, arguments);
      }

      return revokeSession;
    }()
  }, {
    key: "revokeOtherSessions",
    value: function () {
      var _revokeOtherSessions = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee30() {
        return regenerator.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                return _context30.abrupt("return", this.post("/_auth/session/revoke_all", {
                  json: {}
                }));

              case 1:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function revokeOtherSessions() {
        return _revokeOtherSessions.apply(this, arguments);
      }

      return revokeOtherSessions;
    }()
  }, {
    key: "listIdentities",
    value: function () {
      var _listIdentities = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee31() {
        var response;
        return regenerator.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return this.post("/_auth/identity/list", {
                  json: {}
                });

              case 2:
                response = _context31.sent;
                return _context31.abrupt("return", response.identities.map(decodeIdentity));

              case 4:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function listIdentities() {
        return _listIdentities.apply(this, arguments);
      }

      return listIdentities;
    }()
  }, {
    key: "addLoginID",
    value: function () {
      var _addLoginID = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee32() {
        var _len,
            loginIDs,
            _key5,
            mappedLoginIDs,
            _args32 = arguments;

        return regenerator.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                for (_len = _args32.length, loginIDs = new Array(_len), _key5 = 0; _key5 < _len; _key5++) {
                  loginIDs[_key5] = _args32[_key5];
                }

                mappedLoginIDs = loginIDs.map(function (loginID) {
                  var _extractSingleKeyValu = extractSingleKeyValue(loginID, "must provide exactly one login ID"),
                      _extractSingleKeyValu2 = _slicedToArray(_extractSingleKeyValu, 2),
                      key = _extractSingleKeyValu2[0],
                      value = _extractSingleKeyValu2[1];

                  return {
                    key: key,
                    value: value
                  };
                });
                return _context32.abrupt("return", this.post("/_auth/login_id/add", {
                  json: {
                    login_ids: mappedLoginIDs
                  }
                }));

              case 3:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function addLoginID() {
        return _addLoginID.apply(this, arguments);
      }

      return addLoginID;
    }()
  }, {
    key: "removeLoginID",
    value: function () {
      var _removeLoginID = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee33(loginID) {
        var _extractSingleKeyValu3, _extractSingleKeyValu4, key, value;

        return regenerator.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _extractSingleKeyValu3 = extractSingleKeyValue(loginID, "must provide exactly one login ID"), _extractSingleKeyValu4 = _slicedToArray(_extractSingleKeyValu3, 2), key = _extractSingleKeyValu4[0], value = _extractSingleKeyValu4[1];
                return _context33.abrupt("return", this.post("/_auth/login_id/remove", {
                  json: {
                    key: key,
                    value: value
                  }
                }));

              case 2:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function removeLoginID(_x41) {
        return _removeLoginID.apply(this, arguments);
      }

      return removeLoginID;
    }()
  }, {
    key: "updateLoginID",
    value: function () {
      var _updateLoginID = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee34(oldLoginID, newLoginID) {
        var _extractSingleKeyValu5, _extractSingleKeyValu6, oldKey, oldValue, _extractSingleKeyValu7, _extractSingleKeyValu8, newKey, newValue;

        return regenerator.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _extractSingleKeyValu5 = extractSingleKeyValue(oldLoginID, "must provide exactly one old login ID"), _extractSingleKeyValu6 = _slicedToArray(_extractSingleKeyValu5, 2), oldKey = _extractSingleKeyValu6[0], oldValue = _extractSingleKeyValu6[1];
                _extractSingleKeyValu7 = extractSingleKeyValue(newLoginID, "must provide exactly one new login ID"), _extractSingleKeyValu8 = _slicedToArray(_extractSingleKeyValu7, 2), newKey = _extractSingleKeyValu8[0], newValue = _extractSingleKeyValu8[1];
                return _context34.abrupt("return", this.postAndReturnAuthResponse("/_auth/login_id/update", {
                  json: {
                    old_login_id: {
                      key: oldKey,
                      value: oldValue
                    },
                    new_login_id: {
                      key: newKey,
                      value: newValue
                    }
                  }
                }));

              case 3:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function updateLoginID(_x42, _x43) {
        return _updateLoginID.apply(this, arguments);
      }

      return updateLoginID;
    }()
  }, {
    key: "listRecoveryCode",
    value: function () {
      var _listRecoveryCode = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee35() {
        var response;
        return regenerator.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.next = 2;
                return this.post("/_auth/mfa/recovery_code/list", {
                  json: {}
                });

              case 2:
                response = _context35.sent;
                return _context35.abrupt("return", response.recovery_codes);

              case 4:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function listRecoveryCode() {
        return _listRecoveryCode.apply(this, arguments);
      }

      return listRecoveryCode;
    }()
  }, {
    key: "regenerateRecoveryCode",
    value: function () {
      var _regenerateRecoveryCode = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee36() {
        var response;
        return regenerator.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                _context36.next = 2;
                return this.post("/_auth/mfa/recovery_code/regenerate", {
                  json: {}
                });

              case 2:
                response = _context36.sent;
                return _context36.abrupt("return", response.recovery_codes);

              case 4:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function regenerateRecoveryCode() {
        return _regenerateRecoveryCode.apply(this, arguments);
      }

      return regenerateRecoveryCode;
    }()
  }, {
    key: "authenticateWithRecoveryCode",
    value: function () {
      var _authenticateWithRecoveryCode = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee37(code) {
        var payload;
        return regenerator.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                payload = this.makePayloadWithAuthenticationSessionToken({
                  code: code
                });
                return _context37.abrupt("return", this.postAndReturnAuthResponse("/_auth/mfa/recovery_code/authenticate", {
                  json: payload
                }));

              case 2:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function authenticateWithRecoveryCode(_x44) {
        return _authenticateWithRecoveryCode.apply(this, arguments);
      }

      return authenticateWithRecoveryCode;
    }()
  }, {
    key: "getAuthenticators",
    value: function () {
      var _getAuthenticators = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee38() {
        var payload, response;
        return regenerator.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                payload = this.makePayloadWithAuthenticationSessionToken({});
                _context38.next = 3;
                return this.post("/_auth/mfa/authenticator/list", {
                  json: payload
                });

              case 3:
                response = _context38.sent;
                return _context38.abrupt("return", response.authenticators.map(decodeAuthenticator));

              case 5:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function getAuthenticators() {
        return _getAuthenticators.apply(this, arguments);
      }

      return getAuthenticators;
    }()
  }, {
    key: "deleteAuthenticator",
    value: function () {
      var _deleteAuthenticator = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee39(id) {
        return regenerator.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return this.post("/_auth/mfa/authenticator/delete", {
                  json: {
                    authenticator_id: id
                  }
                });

              case 2:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function deleteAuthenticator(_x45) {
        return _deleteAuthenticator.apply(this, arguments);
      }

      return deleteAuthenticator;
    }()
  }, {
    key: "createNewTOTP",
    value: function () {
      var _createNewTOTP = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee40(options) {
        var payload, response;
        return regenerator.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                payload = this.makePayloadWithAuthenticationSessionToken({
                  display_name: options.displayName,
                  issuer: options.issuer,
                  account_name: options.accountName
                });
                _context40.next = 3;
                return this.post("/_auth/mfa/totp/new", {
                  json: payload
                });

              case 3:
                response = _context40.sent;
                return _context40.abrupt("return", {
                  authenticatorID: response.authenticator_id,
                  authenticatorType: response.authenticator_type,
                  secret: response.secret,
                  otpauthURI: response.otpauth_uri,
                  qrCodeImageURI: response.qr_code_image_uri
                });

              case 5:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function createNewTOTP(_x46) {
        return _createNewTOTP.apply(this, arguments);
      }

      return createNewTOTP;
    }()
  }, {
    key: "activateTOTP",
    value: function () {
      var _activateTOTP = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee41(otp) {
        var payload, response;
        return regenerator.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                payload = this.makePayloadWithAuthenticationSessionToken({
                  otp: otp
                });
                _context41.next = 3;
                return this.post("/_auth/mfa/totp/activate", {
                  json: payload
                });

              case 3:
                response = _context41.sent;
                return _context41.abrupt("return", {
                  recoveryCodes: response.recovery_codes
                });

              case 5:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));

      function activateTOTP(_x47) {
        return _activateTOTP.apply(this, arguments);
      }

      return activateTOTP;
    }()
  }, {
    key: "authenticateWithTOTP",
    value: function () {
      var _authenticateWithTOTP = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee42(options) {
        var payload;
        return regenerator.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                payload = this.makePayloadWithAuthenticationSessionToken({
                  request_bearer_token: options.skipMFAForCurrentDevice,
                  otp: options.otp
                });
                return _context42.abrupt("return", this.postAndReturnAuthResponse("/_auth/mfa/totp/authenticate", {
                  json: payload
                }));

              case 2:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function authenticateWithTOTP(_x48) {
        return _authenticateWithTOTP.apply(this, arguments);
      }

      return authenticateWithTOTP;
    }()
  }, {
    key: "createNewOOB",
    value: function () {
      var _createNewOOB = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee43(options) {
        var payload, response;
        return regenerator.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                payload = this.makePayloadWithAuthenticationSessionToken({
                  channel: options.channel,
                  phone: options.phone,
                  email: options.email
                });
                _context43.next = 3;
                return this.post("/_auth/mfa/oob/new", {
                  json: payload
                });

              case 3:
                response = _context43.sent;
                return _context43.abrupt("return", {
                  authenticatorID: response.authenticator_id,
                  authenticatorType: response.authenticator_type,
                  channel: response.channel
                });

              case 5:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));

      function createNewOOB(_x49) {
        return _createNewOOB.apply(this, arguments);
      }

      return createNewOOB;
    }()
  }, {
    key: "activateOOB",
    value: function () {
      var _activateOOB = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee44(code) {
        var payload, response;
        return regenerator.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                payload = this.makePayloadWithAuthenticationSessionToken({
                  code: code
                });
                _context44.next = 3;
                return this.post("/_auth/mfa/oob/activate", {
                  json: payload
                });

              case 3:
                response = _context44.sent;
                return _context44.abrupt("return", {
                  recoveryCodes: response.recovery_codes
                });

              case 5:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));

      function activateOOB(_x50) {
        return _activateOOB.apply(this, arguments);
      }

      return activateOOB;
    }()
  }, {
    key: "triggerOOB",
    value: function () {
      var _triggerOOB = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee45(authenticatorID) {
        var payload;
        return regenerator.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                payload = this.makePayloadWithAuthenticationSessionToken({
                  authenticator_id: authenticatorID
                });
                _context45.next = 3;
                return this.post("/_auth/mfa/oob/trigger", {
                  json: payload
                });

              case 3:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));

      function triggerOOB(_x51) {
        return _triggerOOB.apply(this, arguments);
      }

      return triggerOOB;
    }()
  }, {
    key: "authenticateWithOOB",
    value: function () {
      var _authenticateWithOOB = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee46(options) {
        var payload;
        return regenerator.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                payload = this.makePayloadWithAuthenticationSessionToken({
                  request_bearer_token: options.skipMFAForCurrentDevice,
                  code: options.code
                });
                return _context46.abrupt("return", this.postAndReturnAuthResponse("/_auth/mfa/oob/authenticate", {
                  json: payload
                }));

              case 2:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));

      function authenticateWithOOB(_x52) {
        return _authenticateWithOOB.apply(this, arguments);
      }

      return authenticateWithOOB;
    }()
  }, {
    key: "authenticateWithBearerToken",
    value: function () {
      var _authenticateWithBearerToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee47(bearerToken) {
        var payload;
        return regenerator.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                payload = this.makePayloadWithAuthenticationSessionToken({
                  bearer_token: bearerToken
                });
                return _context47.abrupt("return", this.postAndReturnAuthResponse("/_auth/mfa/bearer_token/authenticate", {
                  json: payload
                }));

              case 2:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));

      function authenticateWithBearerToken(_x53) {
        return _authenticateWithBearerToken.apply(this, arguments);
      }

      return authenticateWithBearerToken;
    }()
  }, {
    key: "revokeAllBearerToken",
    value: function () {
      var _revokeAllBearerToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee48() {
        return regenerator.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                _context48.next = 2;
                return this.post("/_auth/mfa/bearer_token/revoke_all", {
                  json: {}
                });

              case 2:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));

      function revokeAllBearerToken() {
        return _revokeAllBearerToken.apply(this, arguments);
      }

      return revokeAllBearerToken;
    }()
    /**
     * @internal
     */

  }, {
    key: "_presignUpload",
    value: function () {
      var _presignUpload2 = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee49(req) {
        return regenerator.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                return _context49.abrupt("return", this.post("/_asset/presign_upload", {
                  json: req
                }));

              case 1:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function _presignUpload(_x54) {
        return _presignUpload2.apply(this, arguments);
      }

      return _presignUpload;
    }()
    /**
     * @internal
     */

  }, {
    key: "_presignUploadForm",
    value: function () {
      var _presignUploadForm2 = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee50() {
        return regenerator.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                return _context50.abrupt("return", this.post("/_asset/presign_upload_form", {
                  json: {}
                }));

              case 1:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));

      function _presignUploadForm() {
        return _presignUploadForm2.apply(this, arguments);
      }

      return _presignUploadForm;
    }()
  }]);

  return BaseAPIClient;
}();

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultExtraSessionInfoOptions = {
  deviceName: undefined
};
/**
 * @public
 */

function generateOTPAuthURI(options) {
  var issuer = "";

  if (options.issuer) {
    issuer = encodeURI(options.issuer);
  }

  var accountName = encodeURI(options.accountName);
  var path = issuer === "" ? accountName : issuer + ":" + accountName;
  var host = "totp";
  var queryInput = [["secret", options.secret]];

  if (options.issuer !== "") {
    queryInput.push(["issuer", options.issuer]);
  }

  var query = encodeQuery(queryInput);
  return "otpauth://".concat(host, "/").concat(path).concat(query);
}
/**
 * Skygear Auth APIs.
 *
 * @public
 */

var AuthContainer =
/*#__PURE__*/
function () {
  /**
   * Current logged in user.
   */

  /**
   * Identity of current logged in user.
   */

  /**
   * Session ID of current logged in user.
   */

  /**
   * Extra session information to be submitted to server.
   */
  function AuthContainer(parent) {
    _classCallCheck(this, AuthContainer);

    _defineProperty(this, "extraSessionInfoOptions", _objectSpread$1({}, defaultExtraSessionInfoOptions));

    this.parent = parent;
    this.currentUser = null;
    this.currentIdentity = null;
    this.currentSessionID = null; // eslint-disable-next-line @typescript-eslint/no-use-before-define

    this.mfa = new MFAContainer(this);
  }
  /**
   * Save extra session information.
   *
   * @remarks
   * The SDK would populate extra session information from storage
   * when calling {@link Container.configure | configure}.
   */


  _createClass(AuthContainer, [{
    key: "saveExtraSessionInfoOptions",
    value: function () {
      var _saveExtraSessionInfoOptions = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.parent.storage.setExtraSessionInfoOptions(this.parent.name, this.extraSessionInfoOptions));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function saveExtraSessionInfoOptions() {
        return _saveExtraSessionInfoOptions.apply(this, arguments);
      }

      return saveExtraSessionInfoOptions;
    }()
    /**
     * @internal
     */

  }, {
    key: "_getExtraSessionInfo",
    value: function () {
      var _getExtraSessionInfo2 = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee2() {
        var options, hasInfo, info;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = this.extraSessionInfoOptions;
                hasInfo = false;
                info = {};

                if (options.deviceName) {
                  info["device_name"] = options.deviceName;
                  hasInfo = true;
                }

                return _context2.abrupt("return", hasInfo ? info : null);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _getExtraSessionInfo() {
        return _getExtraSessionInfo2.apply(this, arguments);
      }

      return _getExtraSessionInfo;
    }()
    /**
     * @internal
     */

  }, {
    key: "persistAuthResponse",
    value: function () {
      var _persistAuthResponse = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee3(response) {
        var user, identity, accessToken, refreshToken, sessionID, mfaBearerToken;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._clearAuthenticationSession();

              case 2:
                user = response.user, identity = response.identity, accessToken = response.accessToken, refreshToken = response.refreshToken, sessionID = response.sessionID, mfaBearerToken = response.mfaBearerToken;
                _context3.next = 5;
                return this.parent.storage.setUser(this.parent.name, user);

              case 5:
                if (!identity) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 8;
                return this.parent.storage.setIdentity(this.parent.name, identity);

              case 8:
                if (!accessToken) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 11;
                return this.parent.storage.setAccessToken(this.parent.name, accessToken);

              case 11:
                if (!refreshToken) {
                  _context3.next = 14;
                  break;
                }

                _context3.next = 14;
                return this.parent.storage.setRefreshToken(this.parent.name, refreshToken);

              case 14:
                if (!sessionID) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 17;
                return this.parent.storage.setSessionID(this.parent.name, sessionID);

              case 17:
                if (!mfaBearerToken) {
                  _context3.next = 20;
                  break;
                }

                _context3.next = 20;
                return this.parent.storage.setMFABearerToken(this.parent.name, mfaBearerToken);

              case 20:
                this.currentUser = user;

                if (identity) {
                  this.currentIdentity = identity;
                }

                if (accessToken) {
                  this.parent.apiClient._accessToken = accessToken;
                }

                if (sessionID) {
                  this.currentSessionID = sessionID;
                }

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function persistAuthResponse(_x) {
        return _persistAuthResponse.apply(this, arguments);
      }

      return persistAuthResponse;
    }()
    /**
     * @internal
     */

  }, {
    key: "handleAuthenticationSession",
    value: function () {
      var _handleAuthenticationSession = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee4(e) {
        var authenticationSession, mfaBearerToken, bearerToken, response;
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(e instanceof SkygearError && e.reason === "InvalidAuthenticationSession")) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 3;
                return this._clearAuthenticationSession();

              case 3:
                throw e;

              case 4:
                // The error is AuthenticationSession
                authenticationSession = _extractAuthenticationSession(e);

                if (!(authenticationSession != null)) {
                  _context4.next = 30;
                  break;
                }

                _context4.next = 8;
                return this._clearSession();

              case 8:
                _context4.next = 10;
                return this.parent.storage.setAuthenticationSession(this.parent.name, authenticationSession);

              case 10:
                this.parent.apiClient._authenticationSession = authenticationSession; // If the step is MFA, try bearer token

                if (!(authenticationSession.step !== "mfa")) {
                  _context4.next = 13;
                  break;
                }

                throw e;

              case 13:
                _context4.next = 15;
                return this.parent.storage.getMFABearerToken(this.parent.name);

              case 15:
                mfaBearerToken = _context4.sent;
                bearerToken = mfaBearerToken === null ? undefined : mfaBearerToken;
                _context4.prev = 17;
                _context4.next = 20;
                return this.parent.apiClient.authenticateWithBearerToken(bearerToken);

              case 20:
                response = _context4.sent;
                return _context4.abrupt("return", response);

              case 24:
                _context4.prev = 24;
                _context4.t0 = _context4["catch"](17);

                if (!(_context4.t0 instanceof SkygearError && _context4.t0.reason === "InvalidMFABearerToken")) {
                  _context4.next = 29;
                  break;
                }

                _context4.next = 29;
                return this.parent.storage.delMFABearerToken(this.parent.name);

              case 29:
                throw e;

              case 30:
                throw e;

              case 31:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[17, 24]]);
      }));

      function handleAuthenticationSession(_x2) {
        return _handleAuthenticationSession.apply(this, arguments);
      }

      return handleAuthenticationSession;
    }()
    /**
     * @internal
     */

  }, {
    key: "handleAuthResponse",
    value: function () {
      var _handleAuthResponse = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee5(p) {
        var response, _response;

        return regenerator.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return p;

              case 3:
                response = _context5.sent;
                _context5.next = 6;
                return this.persistAuthResponse(response);

              case 6:
                return _context5.abrupt("return", response.user);

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](0);
                _context5.next = 13;
                return this.handleAuthenticationSession(_context5.t0);

              case 13:
                _response = _context5.sent;
                _context5.next = 16;
                return this.persistAuthResponse(_response);

              case 16:
                return _context5.abrupt("return", _response.user);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 9]]);
      }));

      function handleAuthResponse(_x3) {
        return _handleAuthResponse.apply(this, arguments);
      }

      return handleAuthResponse;
    }()
    /**
     * @internal
     */

  }, {
    key: "handleMaybeAuthResponse",
    value: function () {
      var _handleMaybeAuthResponse = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee6(p) {
        var response, _response2;

        return regenerator.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return p;

              case 3:
                response = _context6.sent;

                if (response) {
                  _context6.next = 6;
                  break;
                }

                return _context6.abrupt("return", null);

              case 6:
                _context6.next = 8;
                return this.persistAuthResponse(response);

              case 8:
                return _context6.abrupt("return", response.user);

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](0);
                _context6.next = 15;
                return this.handleAuthenticationSession(_context6.t0);

              case 15:
                _response2 = _context6.sent;
                _context6.next = 18;
                return this.persistAuthResponse(_response2);

              case 18:
                return _context6.abrupt("return", _response2.user);

              case 19:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 11]]);
      }));

      function handleMaybeAuthResponse(_x4) {
        return _handleMaybeAuthResponse.apply(this, arguments);
      }

      return handleMaybeAuthResponse;
    }()
    /**
     * Sign up new user.
     *
     * @example
     * ```ts
     * // Signup with email and password
     * await signup({"email": "test@example.com"}, "password");
     *
     * // Signup with email, username, and password
     * await signup(
     *   [{"email": "test@example.com"}, {"username": "test"}],
     *   "password"
     * );
     *
     * // Signup with email, password, and custom metadata
     * await signup(
     *   {"email": "test@example.com"},
     *   "password",
     *   {"metadata": {"accepted_tos": true}}
     * );
     * ```
     *
     * @param loginIDs - Login IDs
     * @param password - Password
     * @param options - Sign up options
     */

  }, {
    key: "signup",
    value: function () {
      var _signup = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee7(loginIDs, password, options) {
        return regenerator.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", this.handleAuthResponse(this.parent.apiClient.signup(loginIDs, password, options)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function signup(_x5, _x6, _x7) {
        return _signup.apply(this, arguments);
      }

      return signup;
    }()
    /**
     * Sign up new user with email.
     *
     * @remarks
     * Equivalent to {@link AuthContainer.signup}: `signup({"email": email}, password, options)`.
     */

  }, {
    key: "signupWithEmail",
    value: function () {
      var _signupWithEmail = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee8(email, password, options) {
        return regenerator.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", this.signup({
                  email: email
                }, password, options));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function signupWithEmail(_x8, _x9, _x10) {
        return _signupWithEmail.apply(this, arguments);
      }

      return signupWithEmail;
    }()
    /**
     * Sign up new user with username.
     *
     * @remarks
     * Equivalent to {@link AuthContainer.signup}: `signup({"username": username}, password, options)`.
     */

  }, {
    key: "signupWithUsername",
    value: function () {
      var _signupWithUsername = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee9(username, password, options) {
        return regenerator.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", this.signup({
                  username: username
                }, password, options));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function signupWithUsername(_x11, _x12, _x13) {
        return _signupWithUsername.apply(this, arguments);
      }

      return signupWithUsername;
    }()
    /**
     * Login user with password.
     *
     * @example
     * ```ts
     * // Login with email
     * await login("test\@example.com", "password");
     * // Login with username
     * await login("test", "password");
     * ```
     * @param loginID - Login ID
     * @param password - Password
     * @param options - Login options
     */

  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee10(loginID, password, options) {
        return regenerator.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt("return", this.handleAuthResponse(this.parent.apiClient.login(loginID, password, options)));

              case 1:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function login(_x14, _x15, _x16) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
    /**
     * Logout current session.
     *
     * @remarks
     * If `force` parameter is set to `true`, all potential errors (e.g. network
     * error) would be ignored.
     *
     * @param options - Logout options
     */

  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee11() {
        var options,
            _options$force,
            force,
            _args11 = arguments;

        return regenerator.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                options = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : {};
                _options$force = options.force, force = _options$force === void 0 ? false : _options$force;
                _context11.prev = 2;
                _context11.next = 5;
                return this.parent.apiClient.logout();

              case 5:
                _context11.next = 11;
                break;

              case 7:
                _context11.prev = 7;
                _context11.t0 = _context11["catch"](2);

                if (force) {
                  _context11.next = 11;
                  break;
                }

                throw _context11.t0;

              case 11:
                _context11.next = 13;
                return this._clearSession();

              case 13:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[2, 7]]);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
    /**
     * @internal
     */

  }, {
    key: "_clearSession",
    value: function () {
      var _clearSession2 = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee12() {
        return regenerator.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.parent.storage.delUser(this.parent.name);

              case 2:
                _context12.next = 4;
                return this.parent.storage.delIdentity(this.parent.name);

              case 4:
                _context12.next = 6;
                return this.parent.storage.delAccessToken(this.parent.name);

              case 6:
                _context12.next = 8;
                return this.parent.storage.delRefreshToken(this.parent.name);

              case 8:
                _context12.next = 10;
                return this.parent.storage.delSessionID(this.parent.name);

              case 10:
                this.currentUser = null;
                this.currentIdentity = null;
                this.parent.apiClient._accessToken = null;
                this.currentSessionID = null;

              case 14:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function _clearSession() {
        return _clearSession2.apply(this, arguments);
      }

      return _clearSession;
    }()
    /**
     * @internal
     */

  }, {
    key: "_clearAuthenticationSession",
    value: function () {
      var _clearAuthenticationSession2 = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee13() {
        return regenerator.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.parent.storage.delAuthenticationSession(this.parent.name);

              case 2:
                this.parent.apiClient._authenticationSession = null;

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function _clearAuthenticationSession() {
        return _clearAuthenticationSession2.apply(this, arguments);
      }

      return _clearAuthenticationSession;
    }()
    /**
     * @internal
     */

  }, {
    key: "_refreshAccessToken",
    value: function () {
      var _refreshAccessToken2 = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee14() {
        var refreshToken, accessToken;
        return regenerator.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.parent.storage.getRefreshToken(this.parent.name);

              case 2:
                refreshToken = _context14.sent;

                if (refreshToken) {
                  _context14.next = 7;
                  break;
                }

                _context14.next = 6;
                return this._clearSession();

              case 6:
                return _context14.abrupt("return", false);

              case 7:
                _context14.prev = 7;
                _context14.next = 10;
                return this.parent.apiClient.refresh(refreshToken);

              case 10:
                accessToken = _context14.sent;
                _context14.next = 19;
                break;

              case 13:
                _context14.prev = 13;
                _context14.t0 = _context14["catch"](7);

                if (!(_context14.t0 instanceof SkygearError && _context14.t0.reason === "NotAuthenticated")) {
                  _context14.next = 18;
                  break;
                }

                _context14.next = 18;
                return this._clearSession();

              case 18:
                throw _context14.t0;

              case 19:
                _context14.next = 21;
                return this.parent.storage.setAccessToken(this.parent.name, accessToken);

              case 21:
                this.parent.apiClient._accessToken = accessToken;
                return _context14.abrupt("return", true);

              case 23:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[7, 13]]);
      }));

      function _refreshAccessToken() {
        return _refreshAccessToken2.apply(this, arguments);
      }

      return _refreshAccessToken;
    }()
    /**
     * Refreshes and returns current user information.
     */

  }, {
    key: "me",
    value: function () {
      var _me = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee15() {
        return regenerator.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", this.handleAuthResponse(this.parent.apiClient.me()));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function me() {
        return _me.apply(this, arguments);
      }

      return me;
    }()
    /**
     * Changes user password.
     *
     * @param newPassword - New password
     * @param oldPassword - Old password
     */

  }, {
    key: "changePassword",
    value: function () {
      var _changePassword = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee16(newPassword, oldPassword) {
        return regenerator.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", this.handleAuthResponse(this.parent.apiClient.changePassword(newPassword, oldPassword)));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function changePassword(_x17, _x18) {
        return _changePassword.apply(this, arguments);
      }

      return changePassword;
    }()
    /**
     * Updates custom metadata of user.
     *
     * @remarks
     * The provided new metadata object would replace the old metadata.
     *
     * @param metadata - New custom metadata object
     */

  }, {
    key: "updateMetadata",
    value: function () {
      var _updateMetadata = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee17(metadata) {
        return regenerator.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt("return", this.handleAuthResponse(this.parent.apiClient.updateMetadata(metadata)));

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function updateMetadata(_x19) {
        return _updateMetadata.apply(this, arguments);
      }

      return updateMetadata;
    }()
    /**
     * Requests password reset email.
     *
     * @param email - Registered email address of the user
     */

  }, {
    key: "requestForgotPasswordEmail",
    value: function () {
      var _requestForgotPasswordEmail = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee18(email) {
        return regenerator.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", this.parent.apiClient.requestForgotPasswordEmail(email));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function requestForgotPasswordEmail(_x20) {
        return _requestForgotPasswordEmail.apply(this, arguments);
      }

      return requestForgotPasswordEmail;
    }()
    /**
     * Performs password reset.
     *
     * @param form - Information from password reset email
     */

  }, {
    key: "resetPassword",
    value: function () {
      var _resetPassword = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee19(form) {
        return regenerator.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return", this.parent.apiClient.resetPassword(form));

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function resetPassword(_x21) {
        return _resetPassword.apply(this, arguments);
      }

      return resetPassword;
    }()
    /**
     * Requests user email verification.
     *
     * @param email - Registered email address of the user
     */

  }, {
    key: "requestEmailVerification",
    value: function () {
      var _requestEmailVerification = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee20(email) {
        return regenerator.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt("return", this.parent.apiClient.requestEmailVerification(email));

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function requestEmailVerification(_x22) {
        return _requestEmailVerification.apply(this, arguments);
      }

      return requestEmailVerification;
    }()
    /**
     * Requests user phone SMS verification.
     *
     * @param phone - Registered phone number of the user
     */

  }, {
    key: "requestPhoneVerification",
    value: function () {
      var _requestPhoneVerification = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee21(phone) {
        return regenerator.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.abrupt("return", this.parent.apiClient.requestPhoneVerification(phone));

              case 1:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function requestPhoneVerification(_x23) {
        return _requestPhoneVerification.apply(this, arguments);
      }

      return requestPhoneVerification;
    }()
    /**
     * Performs user verification.
     *
     * @param code - Verification code sent to user
     */

  }, {
    key: "verifyWithCode",
    value: function () {
      var _verifyWithCode = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee22(code) {
        return regenerator.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", this.parent.apiClient.verifyWithCode(code));

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function verifyWithCode(_x24) {
        return _verifyWithCode.apply(this, arguments);
      }

      return verifyWithCode;
    }()
    /**
     * Login user with custom token.
     *
     * @param token - Custom authentication token
     * @param options - SSO login options
     */

  }, {
    key: "loginWithCustomToken",
    value: function () {
      var _loginWithCustomToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee23(token, options) {
        return regenerator.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                return _context23.abrupt("return", this.handleAuthResponse(this.parent.apiClient.loginWithCustomToken(token, options)));

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function loginWithCustomToken(_x25, _x26) {
        return _loginWithCustomToken.apply(this, arguments);
      }

      return loginWithCustomToken;
    }()
    /**
     * Deletes OAuth SSO provider.
     *
     * @param providerID - SSO provider ID
     */

  }, {
    key: "deleteOAuthProvider",
    value: function () {
      var _deleteOAuthProvider = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee24(providerID) {
        return regenerator.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                return _context24.abrupt("return", this.parent.apiClient.deleteOAuthProvider(providerID));

              case 1:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function deleteOAuthProvider(_x27) {
        return _deleteOAuthProvider.apply(this, arguments);
      }

      return deleteOAuthProvider;
    }()
    /**
     * Login with OAuth SSO provider using access token.
     *
     * @remarks
     * This feature must be enabled in configuration, otherwise it will fail.
     *
     * @param providerID - SSO provider ID
     * @param accessToken - SSO provider access token
     * @param options - SSO login options
     */

  }, {
    key: "loginOAuthProviderWithAccessToken",
    value: function () {
      var _loginOAuthProviderWithAccessToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee25(providerID, accessToken, options) {
        return regenerator.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                return _context25.abrupt("return", this.handleAuthResponse(this.parent.apiClient.loginOAuthProviderWithAccessToken(providerID, accessToken, options)));

              case 1:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function loginOAuthProviderWithAccessToken(_x28, _x29, _x30) {
        return _loginOAuthProviderWithAccessToken.apply(this, arguments);
      }

      return loginOAuthProviderWithAccessToken;
    }()
    /**
     * Links with OAuth SSO provider using access token.
     *
     * @remarks
     * This feature must be enabled in configuration, otherwise it will fail.
     *
     * @param providerID - SSO provider ID
     * @param accessToken - SSO provider access token
     */

  }, {
    key: "linkOAuthProviderWithAccessToken",
    value: function () {
      var _linkOAuthProviderWithAccessToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee26(providerID, accessToken) {
        return regenerator.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                return _context26.abrupt("return", this.handleAuthResponse(this.parent.apiClient.linkOAuthProviderWithAccessToken(providerID, accessToken)));

              case 1:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function linkOAuthProviderWithAccessToken(_x31, _x32) {
        return _linkOAuthProviderWithAccessToken.apply(this, arguments);
      }

      return linkOAuthProviderWithAccessToken;
    }()
    /**
     * Lists all active user sessions.
     */

  }, {
    key: "listSessions",
    value: function () {
      var _listSessions = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee27() {
        return regenerator.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                return _context27.abrupt("return", this.parent.apiClient.listSessions());

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function listSessions() {
        return _listSessions.apply(this, arguments);
      }

      return listSessions;
    }()
    /**
     * Gets information on specified active user session.
     */

  }, {
    key: "getSession",
    value: function () {
      var _getSession = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee28(id) {
        return regenerator.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                return _context28.abrupt("return", this.parent.apiClient.getSession(id));

              case 1:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function getSession(_x33) {
        return _getSession.apply(this, arguments);
      }

      return getSession;
    }()
    /**
     * Revokes the specified user session.
     *
     * @param id - Session ID
     */

  }, {
    key: "revokeSession",
    value: function () {
      var _revokeSession = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee29(id) {
        return regenerator.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                return _context29.abrupt("return", this.parent.apiClient.revokeSession(id));

              case 1:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function revokeSession(_x34) {
        return _revokeSession.apply(this, arguments);
      }

      return revokeSession;
    }()
    /**
     * Revokes all other active user sessions.
     */

  }, {
    key: "revokeOtherSessions",
    value: function () {
      var _revokeOtherSessions = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee30() {
        return regenerator.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                return _context30.abrupt("return", this.parent.apiClient.revokeOtherSessions());

              case 1:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function revokeOtherSessions() {
        return _revokeOtherSessions.apply(this, arguments);
      }

      return revokeOtherSessions;
    }()
    /**
     * Lists all identities of current user.
     */

  }, {
    key: "listIdentities",
    value: function () {
      var _listIdentities = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee31() {
        return regenerator.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                return _context31.abrupt("return", this.parent.apiClient.listIdentities());

              case 1:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function listIdentities() {
        return _listIdentities.apply(this, arguments);
      }

      return listIdentities;
    }()
    /**
     * Adds new login ID to current user.
     */

  }, {
    key: "addLoginID",
    value: function () {
      var _addLoginID = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee32(loginID) {
        return regenerator.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                return _context32.abrupt("return", this.parent.apiClient.addLoginID(loginID));

              case 1:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function addLoginID(_x35) {
        return _addLoginID.apply(this, arguments);
      }

      return addLoginID;
    }()
    /**
     * Removes login ID from current user.
     */

  }, {
    key: "removeLoginID",
    value: function () {
      var _removeLoginID = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee33(loginID) {
        return regenerator.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                return _context33.abrupt("return", this.parent.apiClient.removeLoginID(loginID));

              case 1:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function removeLoginID(_x36) {
        return _removeLoginID.apply(this, arguments);
      }

      return removeLoginID;
    }()
    /**
     * Updates specified login ID for current user.
     */

  }, {
    key: "updateLoginID",
    value: function () {
      var _updateLoginID = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee34(oldLoginID, newLoginID) {
        return regenerator.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                return _context34.abrupt("return", this.handleAuthResponse(this.parent.apiClient.updateLoginID(oldLoginID, newLoginID)));

              case 1:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function updateLoginID(_x37, _x38) {
        return _updateLoginID.apply(this, arguments);
      }

      return updateLoginID;
    }()
  }]);

  return AuthContainer;
}();
/**
 * Skygear Auth Multi-Factor-Authentication APIs.
 *
 * @public
 */

var MFAContainer =
/*#__PURE__*/
function () {
  function MFAContainer(parent) {
    _classCallCheck(this, MFAContainer);

    this.parent = parent;
  }
  /**
   * Returns a list of MFA recovery code.
   *
   * @remarks
   * This feature must be enabled in configuration, otherwise it will fail.
   */


  _createClass(MFAContainer, [{
    key: "listRecoveryCode",
    value: function () {
      var _listRecoveryCode = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee35() {
        return regenerator.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                return _context35.abrupt("return", this.parent.parent.apiClient.listRecoveryCode());

              case 1:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function listRecoveryCode() {
        return _listRecoveryCode.apply(this, arguments);
      }

      return listRecoveryCode;
    }()
    /**
     * Regenerates MFA recovery codes.
     *
     * @returns The newly generated recovery codes
     */

  }, {
    key: "regenerateRecoveryCode",
    value: function () {
      var _regenerateRecoveryCode = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee36() {
        return regenerator.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                return _context36.abrupt("return", this.parent.parent.apiClient.regenerateRecoveryCode());

              case 1:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, this);
      }));

      function regenerateRecoveryCode() {
        return _regenerateRecoveryCode.apply(this, arguments);
      }

      return regenerateRecoveryCode;
    }()
    /**
     * Perform MFA using recovery code.
     *
     * @param code - MFA recovery code
     */

  }, {
    key: "authenticateWithRecoveryCode",
    value: function () {
      var _authenticateWithRecoveryCode = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee37(code) {
        return regenerator.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                return _context37.abrupt("return", this.parent.handleAuthResponse(this.parent.parent.apiClient.authenticateWithRecoveryCode(code)));

              case 1:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));

      function authenticateWithRecoveryCode(_x39) {
        return _authenticateWithRecoveryCode.apply(this, arguments);
      }

      return authenticateWithRecoveryCode;
    }()
    /**
     * Returns a list of configured MFA authenticators.
     */

  }, {
    key: "getAuthenticators",
    value: function () {
      var _getAuthenticators = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee38() {
        return regenerator.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                return _context38.abrupt("return", this.parent.parent.apiClient.getAuthenticators());

              case 1:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));

      function getAuthenticators() {
        return _getAuthenticators.apply(this, arguments);
      }

      return getAuthenticators;
    }()
    /**
     * Delete the MFA authenticator with specified ID.
     *
     * @param id - Authenticator ID
     */

  }, {
    key: "deleteAuthenticator",
    value: function () {
      var _deleteAuthenticator = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee39(id) {
        return regenerator.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                return _context39.abrupt("return", this.parent.parent.apiClient.deleteAuthenticator(id));

              case 1:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function deleteAuthenticator(_x40) {
        return _deleteAuthenticator.apply(this, arguments);
      }

      return deleteAuthenticator;
    }()
    /**
     * Creates new time-based one time password (TOTP) MFA authenticator.
     *
     * @param options - TOTP configuration
     */

  }, {
    key: "createNewTOTP",
    value: function () {
      var _createNewTOTP = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee40(options) {
        return regenerator.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                return _context40.abrupt("return", this.parent.parent.apiClient.createNewTOTP(options));

              case 1:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));

      function createNewTOTP(_x41) {
        return _createNewTOTP.apply(this, arguments);
      }

      return createNewTOTP;
    }()
    /**
     * Activates time-based one time password (TOTP) MFA authenticator.
     *
     * @param otp - TOTP code
     */

  }, {
    key: "activateTOTP",
    value: function () {
      var _activateTOTP = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee41(otp) {
        return regenerator.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                return _context41.abrupt("return", this.parent.parent.apiClient.activateTOTP(otp));

              case 1:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));

      function activateTOTP(_x42) {
        return _activateTOTP.apply(this, arguments);
      }

      return activateTOTP;
    }()
    /**
     * Perform MFA using time-based one time password (TOTP) MFA authenticator.
     *
     * @param options - Authentication options
     */

  }, {
    key: "authenticateWithTOTP",
    value: function () {
      var _authenticateWithTOTP = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee42(options) {
        return regenerator.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                return _context42.abrupt("return", this.parent.handleAuthResponse(this.parent.parent.apiClient.authenticateWithTOTP(options)));

              case 1:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));

      function authenticateWithTOTP(_x43) {
        return _authenticateWithTOTP.apply(this, arguments);
      }

      return authenticateWithTOTP;
    }()
    /**
     * Creates new out-of-band (OOB) MFA authenticator.
     *
     * @param options - OOB configuration
     */

  }, {
    key: "createNewOOB",
    value: function () {
      var _createNewOOB = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee43(options) {
        return regenerator.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                return _context43.abrupt("return", this.parent.parent.apiClient.createNewOOB(options));

              case 1:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));

      function createNewOOB(_x44) {
        return _createNewOOB.apply(this, arguments);
      }

      return createNewOOB;
    }()
    /**
     * Activates out-of-band (OOB) MFA authenticator.
     *
     * @param code - MFA code
     */

  }, {
    key: "activateOOB",
    value: function () {
      var _activateOOB = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee44(code) {
        return regenerator.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                return _context44.abrupt("return", this.parent.parent.apiClient.activateOOB(code));

              case 1:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));

      function activateOOB(_x45) {
        return _activateOOB.apply(this, arguments);
      }

      return activateOOB;
    }()
    /**
     * Triggers out-of-band (OOB) MFA.
     *
     * @param authenticatorID - Authenticator ID
     */

  }, {
    key: "triggerOOB",
    value: function () {
      var _triggerOOB = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee45(authenticatorID) {
        return regenerator.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                return _context45.abrupt("return", this.parent.parent.apiClient.triggerOOB(authenticatorID));

              case 1:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, this);
      }));

      function triggerOOB(_x46) {
        return _triggerOOB.apply(this, arguments);
      }

      return triggerOOB;
    }()
    /**
     * Performs MFA using out-of-band (OOB) MFA authenticator.
     *
     * @param options - Authentication options
     */

  }, {
    key: "authenticateWithOOB",
    value: function () {
      var _authenticateWithOOB = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee46(options) {
        return regenerator.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                return _context46.abrupt("return", this.parent.handleAuthResponse(this.parent.parent.apiClient.authenticateWithOOB(options)));

              case 1:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));

      function authenticateWithOOB(_x47) {
        return _authenticateWithOOB.apply(this, arguments);
      }

      return authenticateWithOOB;
    }()
    /**
     * Revokes all MFA trusted devices.
     */

  }, {
    key: "revokeAllTrustedDevices",
    value: function () {
      var _revokeAllTrustedDevices = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee47() {
        return regenerator.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                _context47.next = 2;
                return this.parent.parent.apiClient.revokeAllBearerToken();

              case 2:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));

      function revokeAllTrustedDevices() {
        return _revokeAllTrustedDevices.apply(this, arguments);
      }

      return revokeAllTrustedDevices;
    }()
  }]);

  return MFAContainer;
}();
/**
 * Skygear APIs container.
 *
 * @remarks
 * This is the base class to Skygear APIs.
 * Consumers should use platform-specific containers instead.
 *
 * @public
 */

var Container =
/*#__PURE__*/
function () {
  /**
   * Unique ID for this container.
   * @defaultValue "default"
   */
  function Container(options) {
    _classCallCheck(this, Container);

    if (!options.apiClient) {
      throw Error("missing apiClient");
    }

    if (!options.storage) {
      throw Error("missing storage");
    }

    this.name = options.name || "default";
    this.apiClient = options.apiClient;
    this.storage = options.storage;
    this.auth = new AuthContainer(this);
  }
  /**
   * Configure this container with connection information.
   *
   * @param options - Skygear connection information
   */


  _createClass(Container, [{
    key: "configure",
    value: function () {
      var _configure = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee48(options) {
        var authenticationSession, accessToken, user, identity, sessionID, extraSessionInfoOptions;
        return regenerator.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                this.apiClient.apiKey = options.apiKey;
                this.apiClient.endpoint = _removeTrailingSlash(options.endpoint);
                _context48.next = 4;
                return this.storage.getAuthenticationSession(this.name);

              case 4:
                authenticationSession = _context48.sent;
                this.apiClient._authenticationSession = authenticationSession;
                _context48.next = 8;
                return this.storage.getAccessToken(this.name);

              case 8:
                accessToken = _context48.sent;
                this.apiClient._accessToken = accessToken;
                _context48.next = 12;
                return this.storage.getUser(this.name);

              case 12:
                user = _context48.sent;
                this.auth.currentUser = user;
                _context48.next = 16;
                return this.storage.getIdentity(this.name);

              case 16:
                identity = _context48.sent;
                this.auth.currentIdentity = identity;
                _context48.next = 20;
                return this.storage.getSessionID(this.name);

              case 20:
                sessionID = _context48.sent;
                this.auth.currentSessionID = sessionID;
                _context48.next = 24;
                return this.storage.getExtraSessionInfoOptions(this.name);

              case 24:
                extraSessionInfoOptions = _context48.sent;
                this.auth.extraSessionInfoOptions = _objectSpread$1({}, defaultExtraSessionInfoOptions, {}, extraSessionInfoOptions);
                this.apiClient.refreshTokenFunction = this.auth._refreshAccessToken.bind(this.auth);
                this.apiClient.getExtraSessionInfo = this.auth._getExtraSessionInfo.bind(this.auth);

              case 28:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));

      function configure(_x48) {
        return _configure.apply(this, arguments);
      }

      return configure;
    }()
    /**
     * `fetch` function for calling microservices.
     *
     * @remarks
     * This function has same behavior as the standard `fetch` function, except
     * it will also handle Skygear authorization mechanism automatically (e.g.
     * attaching API key, access token, refreshing access token).
     */

  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee49(input, init) {
        return regenerator.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                return _context49.abrupt("return", this.apiClient.fetch(input, init));

              case 1:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));

      function fetch(_x49, _x50) {
        return _fetch.apply(this, arguments);
      }

      return fetch;
    }()
  }]);

  return Container;
}();

function scopedKey(key) {
  return "skygear2_".concat(key);
}

function keyAccessToken(name) {
  return "".concat(name, "_accessToken");
}

function keyRefreshToken(name) {
  return "".concat(name, "_refreshToken");
}

function keySessionID(name) {
  return "".concat(name, "_sessionID");
}

function keyUser(name) {
  return "".concat(name, "_user");
}

function keyIdentity(name) {
  return "".concat(name, "_identity");
}

function keyOAuthRedirectAction(name) {
  return "".concat(name, "_oauthRedirectAction");
}

function keyOAuthCodeVerifier(name) {
  return "".concat(name, "_oauthAuthorizationCode");
}

function keyExtraSessionInfoOptions(name) {
  return "".concat(name, "_extra_session_info_options");
}

function keyAuthenticationSession(name) {
  return "".concat(name, "_authenticationSession");
}

function keyMFABearerToken(name) {
  return "".concat(name, "_mfaBearerToken");
}
/**
 * @internal
 */


var _GlobalJSONStorage =
/*#__PURE__*/
function () {
  function _GlobalJSONStorage(driver) {
    _classCallCheck(this, _GlobalJSONStorage);

    this.driver = driver;
  }

  _createClass(_GlobalJSONStorage, [{
    key: "safeDel",
    value: function () {
      var _safeDel = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee(key) {
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                key = scopedKey(key);
                _context.prev = 1;
                _context.next = 4;
                return this.driver.del(key);

              case 4:
                _context.next = 8;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 6]]);
      }));

      function safeDel(_x) {
        return _safeDel.apply(this, arguments);
      }

      return safeDel;
    }()
  }, {
    key: "safeGet",
    value: function () {
      var _safeGet = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee2(key) {
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                key = scopedKey(key);
                _context2.prev = 1;
                return _context2.abrupt("return", this.driver.get(key));

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2["catch"](1);
                return _context2.abrupt("return", null);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 5]]);
      }));

      function safeGet(_x2) {
        return _safeGet.apply(this, arguments);
      }

      return safeGet;
    }()
  }, {
    key: "safeGetJSON",
    value: function () {
      var _safeGetJSON = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee3(key) {
        var jsonString;
        return regenerator.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.safeGet(key);

              case 2:
                jsonString = _context3.sent;

                if (!(jsonString == null)) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", undefined);

              case 5:
                _context3.prev = 5;
                return _context3.abrupt("return", JSON.parse(jsonString));

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](5);
                return _context3.abrupt("return", undefined);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 9]]);
      }));

      function safeGetJSON(_x3) {
        return _safeGetJSON.apply(this, arguments);
      }

      return safeGetJSON;
    }()
  }, {
    key: "safeSet",
    value: function () {
      var _safeSet = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee4(key, value) {
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                key = scopedKey(key);
                _context4.prev = 1;
                _context4.next = 4;
                return this.driver.set(key, value);

              case 4:
                _context4.next = 8;
                break;

              case 6:
                _context4.prev = 6;
                _context4.t0 = _context4["catch"](1);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 6]]);
      }));

      function safeSet(_x4, _x5) {
        return _safeSet.apply(this, arguments);
      }

      return safeSet;
    }()
  }, {
    key: "safeSetJSON",
    value: function () {
      var _safeSetJSON = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee5(key, value) {
        var jsonString;
        return regenerator.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                jsonString = JSON.stringify(value);
                _context5.next = 4;
                return this.safeSet(key, jsonString);

              case 4:
                _context5.next = 8;
                break;

              case 6:
                _context5.prev = 6;
                _context5.t0 = _context5["catch"](0);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 6]]);
      }));

      function safeSetJSON(_x6, _x7) {
        return _safeSetJSON.apply(this, arguments);
      }

      return safeSetJSON;
    }()
  }]);

  return _GlobalJSONStorage;
}();
/**
 * @public
 */

var GlobalJSONContainerStorage =
/*#__PURE__*/
function () {
  function GlobalJSONContainerStorage(driver) {
    _classCallCheck(this, GlobalJSONContainerStorage);

    this.storage = new _GlobalJSONStorage(driver);
  }

  _createClass(GlobalJSONContainerStorage, [{
    key: "setUser",
    value: function () {
      var _setUser = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee6(namespace, user) {
        var userJSON;
        return regenerator.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                userJSON = encodeUser(user);
                _context6.next = 3;
                return this.storage.safeSetJSON(keyUser(namespace), userJSON);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function setUser(_x8, _x9) {
        return _setUser.apply(this, arguments);
      }

      return setUser;
    }()
  }, {
    key: "setIdentity",
    value: function () {
      var _setIdentity = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee7(namespace, identity) {
        var identityJSON;
        return regenerator.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                identityJSON = encodeIdentity(identity);
                _context7.next = 3;
                return this.storage.safeSetJSON(keyIdentity(namespace), identityJSON);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function setIdentity(_x10, _x11) {
        return _setIdentity.apply(this, arguments);
      }

      return setIdentity;
    }()
  }, {
    key: "setAccessToken",
    value: function () {
      var _setAccessToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee8(namespace, accessToken) {
        return regenerator.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.storage.safeSet(keyAccessToken(namespace), accessToken);

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setAccessToken(_x12, _x13) {
        return _setAccessToken.apply(this, arguments);
      }

      return setAccessToken;
    }()
  }, {
    key: "setRefreshToken",
    value: function () {
      var _setRefreshToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee9(namespace, refreshToken) {
        return regenerator.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.storage.safeSet(keyRefreshToken(namespace), refreshToken);

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function setRefreshToken(_x14, _x15) {
        return _setRefreshToken.apply(this, arguments);
      }

      return setRefreshToken;
    }()
  }, {
    key: "setSessionID",
    value: function () {
      var _setSessionID = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee10(namespace, sessionID) {
        return regenerator.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.storage.safeSet(keySessionID(namespace), sessionID);

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function setSessionID(_x16, _x17) {
        return _setSessionID.apply(this, arguments);
      }

      return setSessionID;
    }()
  }, {
    key: "setOAuthRedirectAction",
    value: function () {
      var _setOAuthRedirectAction = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee11(namespace, oauthRedirectAction) {
        return regenerator.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.storage.safeSet(keyOAuthRedirectAction(namespace), oauthRedirectAction);

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function setOAuthRedirectAction(_x18, _x19) {
        return _setOAuthRedirectAction.apply(this, arguments);
      }

      return setOAuthRedirectAction;
    }()
  }, {
    key: "setOAuthCodeVerifier",
    value: function () {
      var _setOAuthCodeVerifier = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee12(namespace, authorizationCode) {
        return regenerator.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.storage.safeSet(keyOAuthCodeVerifier(namespace), authorizationCode);

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function setOAuthCodeVerifier(_x20, _x21) {
        return _setOAuthCodeVerifier.apply(this, arguments);
      }

      return setOAuthCodeVerifier;
    }()
  }, {
    key: "setExtraSessionInfoOptions",
    value: function () {
      var _setExtraSessionInfoOptions = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee13(namespace, options) {
        return regenerator.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.storage.safeSetJSON(keyExtraSessionInfoOptions(namespace), _encodeExtraSessionInfoOptions(options));

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function setExtraSessionInfoOptions(_x22, _x23) {
        return _setExtraSessionInfoOptions.apply(this, arguments);
      }

      return setExtraSessionInfoOptions;
    }()
  }, {
    key: "setAuthenticationSession",
    value: function () {
      var _setAuthenticationSession = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee14(namespace, authenticationSession) {
        return regenerator.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.storage.safeSetJSON(keyAuthenticationSession(namespace), authenticationSession);

              case 2:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function setAuthenticationSession(_x24, _x25) {
        return _setAuthenticationSession.apply(this, arguments);
      }

      return setAuthenticationSession;
    }()
  }, {
    key: "setMFABearerToken",
    value: function () {
      var _setMFABearerToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee15(namespace, mfaBearerToken) {
        return regenerator.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.storage.safeSet(keyMFABearerToken(namespace), mfaBearerToken);

              case 2:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function setMFABearerToken(_x26, _x27) {
        return _setMFABearerToken.apply(this, arguments);
      }

      return setMFABearerToken;
    }()
  }, {
    key: "getUser",
    value: function () {
      var _getUser = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee16(namespace) {
        var userJSON;
        return regenerator.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.storage.safeGetJSON(keyUser(namespace));

              case 2:
                userJSON = _context16.sent;

                if (!userJSON) {
                  _context16.next = 5;
                  break;
                }

                return _context16.abrupt("return", decodeUser(userJSON));

              case 5:
                return _context16.abrupt("return", null);

              case 6:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function getUser(_x28) {
        return _getUser.apply(this, arguments);
      }

      return getUser;
    }()
  }, {
    key: "getIdentity",
    value: function () {
      var _getIdentity = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee17(namespace) {
        var identityJSON;
        return regenerator.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.storage.safeGetJSON(keyIdentity(namespace));

              case 2:
                identityJSON = _context17.sent;

                if (!identityJSON) {
                  _context17.next = 5;
                  break;
                }

                return _context17.abrupt("return", decodeIdentity(identityJSON));

              case 5:
                return _context17.abrupt("return", null);

              case 6:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function getIdentity(_x29) {
        return _getIdentity.apply(this, arguments);
      }

      return getIdentity;
    }()
  }, {
    key: "getAccessToken",
    value: function () {
      var _getAccessToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee18(namespace) {
        return regenerator.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", this.storage.safeGet(keyAccessToken(namespace)));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function getAccessToken(_x30) {
        return _getAccessToken.apply(this, arguments);
      }

      return getAccessToken;
    }()
  }, {
    key: "getRefreshToken",
    value: function () {
      var _getRefreshToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee19(namespace) {
        return regenerator.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return", this.storage.safeGet(keyRefreshToken(namespace)));

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function getRefreshToken(_x31) {
        return _getRefreshToken.apply(this, arguments);
      }

      return getRefreshToken;
    }()
  }, {
    key: "getSessionID",
    value: function () {
      var _getSessionID = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee20(namespace) {
        return regenerator.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt("return", this.storage.safeGet(keySessionID(namespace)));

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function getSessionID(_x32) {
        return _getSessionID.apply(this, arguments);
      }

      return getSessionID;
    }()
  }, {
    key: "getOAuthRedirectAction",
    value: function () {
      var _getOAuthRedirectAction = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee21(namespace) {
        return regenerator.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                return _context21.abrupt("return", this.storage.safeGet(keyOAuthRedirectAction(namespace)));

              case 1:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function getOAuthRedirectAction(_x33) {
        return _getOAuthRedirectAction.apply(this, arguments);
      }

      return getOAuthRedirectAction;
    }()
  }, {
    key: "getOAuthCodeVerifier",
    value: function () {
      var _getOAuthCodeVerifier = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee22(namespace) {
        return regenerator.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                return _context22.abrupt("return", this.storage.safeGet(keyOAuthCodeVerifier(namespace)));

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function getOAuthCodeVerifier(_x34) {
        return _getOAuthCodeVerifier.apply(this, arguments);
      }

      return getOAuthCodeVerifier;
    }()
  }, {
    key: "getExtraSessionInfoOptions",
    value: function () {
      var _getExtraSessionInfoOptions = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee23(namespace) {
        var optionJSON;
        return regenerator.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return this.storage.safeGetJSON(keyExtraSessionInfoOptions(namespace));

              case 2:
                optionJSON = _context23.sent;

                if (!optionJSON) {
                  _context23.next = 5;
                  break;
                }

                return _context23.abrupt("return", _decodeExtraSessionInfoOptions(optionJSON));

              case 5:
                return _context23.abrupt("return", null);

              case 6:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function getExtraSessionInfoOptions(_x35) {
        return _getExtraSessionInfoOptions.apply(this, arguments);
      }

      return getExtraSessionInfoOptions;
    }()
  }, {
    key: "getAuthenticationSession",
    value: function () {
      var _getAuthenticationSession = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee24(namespace) {
        var j;
        return regenerator.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return this.storage.safeGetJSON(keyAuthenticationSession(namespace));

              case 2:
                j = _context24.sent;

                if (!(j !== undefined)) {
                  _context24.next = 5;
                  break;
                }

                return _context24.abrupt("return", j);

              case 5:
                return _context24.abrupt("return", null);

              case 6:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function getAuthenticationSession(_x36) {
        return _getAuthenticationSession.apply(this, arguments);
      }

      return getAuthenticationSession;
    }()
  }, {
    key: "getMFABearerToken",
    value: function () {
      var _getMFABearerToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee25(namespace) {
        return regenerator.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                return _context25.abrupt("return", this.storage.safeGet(keyMFABearerToken(namespace)));

              case 1:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function getMFABearerToken(_x37) {
        return _getMFABearerToken.apply(this, arguments);
      }

      return getMFABearerToken;
    }()
  }, {
    key: "delUser",
    value: function () {
      var _delUser = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee26(namespace) {
        return regenerator.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return this.storage.safeDel(keyUser(namespace));

              case 2:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function delUser(_x38) {
        return _delUser.apply(this, arguments);
      }

      return delUser;
    }()
  }, {
    key: "delIdentity",
    value: function () {
      var _delIdentity = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee27(namespace) {
        return regenerator.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return this.storage.safeDel(keyIdentity(namespace));

              case 2:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function delIdentity(_x39) {
        return _delIdentity.apply(this, arguments);
      }

      return delIdentity;
    }()
  }, {
    key: "delAccessToken",
    value: function () {
      var _delAccessToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee28(namespace) {
        return regenerator.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return this.storage.safeDel(keyAccessToken(namespace));

              case 2:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function delAccessToken(_x40) {
        return _delAccessToken.apply(this, arguments);
      }

      return delAccessToken;
    }()
  }, {
    key: "delRefreshToken",
    value: function () {
      var _delRefreshToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee29(namespace) {
        return regenerator.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return this.storage.safeDel(keyRefreshToken(namespace));

              case 2:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function delRefreshToken(_x41) {
        return _delRefreshToken.apply(this, arguments);
      }

      return delRefreshToken;
    }()
  }, {
    key: "delSessionID",
    value: function () {
      var _delSessionID = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee30(namespace) {
        return regenerator.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return this.storage.safeDel(keySessionID(namespace));

              case 2:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function delSessionID(_x42) {
        return _delSessionID.apply(this, arguments);
      }

      return delSessionID;
    }()
  }, {
    key: "delOAuthRedirectAction",
    value: function () {
      var _delOAuthRedirectAction = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee31(namespace) {
        return regenerator.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return this.storage.safeDel(keyOAuthRedirectAction(namespace));

              case 2:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function delOAuthRedirectAction(_x43) {
        return _delOAuthRedirectAction.apply(this, arguments);
      }

      return delOAuthRedirectAction;
    }()
  }, {
    key: "delOAuthCodeVerifier",
    value: function () {
      var _delOAuthCodeVerifier = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee32(namespace) {
        return regenerator.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return this.storage.safeDel(keyOAuthCodeVerifier(namespace));

              case 2:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function delOAuthCodeVerifier(_x44) {
        return _delOAuthCodeVerifier.apply(this, arguments);
      }

      return delOAuthCodeVerifier;
    }()
  }, {
    key: "delAuthenticationSession",
    value: function () {
      var _delAuthenticationSession = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee33(namespace) {
        return regenerator.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return this.storage.safeDel(keyAuthenticationSession(namespace));

              case 2:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function delAuthenticationSession(_x45) {
        return _delAuthenticationSession.apply(this, arguments);
      }

      return delAuthenticationSession;
    }()
  }, {
    key: "delMFABearerToken",
    value: function () {
      var _delMFABearerToken = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee34(namespace) {
        return regenerator.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _context34.next = 2;
                return this.storage.safeDel(keyMFABearerToken(namespace));

              case 2:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function delMFABearerToken(_x46) {
        return _delMFABearerToken.apply(this, arguments);
      }

      return delMFABearerToken;
    }()
  }]);

  return GlobalJSONContainerStorage;
}();

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
/**
 * @public
 */

/**
 * Image processing pipeline builder.
 * @public
 */
var ImageProcessingPipelineBuilder =
/*#__PURE__*/
function () {
  function ImageProcessingPipelineBuilder() {
    _classCallCheck(this, ImageProcessingPipelineBuilder);

    this._ops = [];
  }
  /**
   * Specifies the output format of the image.
   * @param format - Image format
   */


  _createClass(ImageProcessingPipelineBuilder, [{
    key: "format",
    value: function format(_format) {
      this._ops.push({
        op: "format",
        format: _format
      });

      return this;
    }
    /**
     * Specifies the quality of the output image.
     * @param absoluteQuality - Quality (1 - 100)
     */

  }, {
    key: "quality",
    value: function quality(absoluteQuality) {
      this._ops.push({
        op: "quality",
        absoluteQuality: absoluteQuality
      });

      return this;
    }
    /**
     * Specifies image resizing operation.
     *
     * @param options - Resize options
     */

  }, {
    key: "resize",
    value: function resize(options) {
      this._ops.push(_objectSpread$2({
        op: "resize"
      }, options));

      return this;
    }
    /**
     * Returns the query parameter name to be used.
     */

  }, {
    key: "getName",
    value: function getName() {
      return "pipeline";
    }
    /**
     * Returns the built pipeline string to be used as query parameter value.
     */

  }, {
    key: "getValue",
    value: function getValue() {
      var parts = ["image"];

      for (var _i2 = 0, _this$_ops2 = this._ops; _i2 < _this$_ops2.length; _i2++) {
        var op = _this$_ops2[_i2];

        switch (op.op) {
          case "format":
            parts.push(renderFormat(op));
            break;

          case "quality":
            parts.push(renderQuality(op));
            break;

          case "resize":
            parts.push(renderResize(op));
            break;
        }
      }

      return parts.join("/");
    }
    /**
     * Returns the provided URL with added pipeline parameter.
     *
     * @example
     * ```ts
     * new ImageProcessingPipelineBuilder()
     *   .format("jpg")
     *   .setToURLString("https://example.com");
     * // http://example.com?pipeline=image%2Fformat%2Cjpg
     * ```
     * @param urlStr - input URL
     */

  }, {
    key: "setToURLString",
    value: function setToURLString(urlStr) {
      var fragmentIndex = urlStr.indexOf("#");
      var queryIndex = urlStr.indexOf("?");
      var queryParam = this.getName() + "=" + encodeQueryComponent(this.getValue());
      var anythingElse = "";
      var query = "";
      var fragment = "";

      if (fragmentIndex < 0) {
        fragment = "";

        if (queryIndex < 0) {
          anythingElse = urlStr;
          query = "";
        } else {
          anythingElse = urlStr.slice(0, queryIndex);
          query = urlStr.slice(queryIndex + 1);
        }
      } else {
        fragment = urlStr.slice(fragmentIndex + 1);

        if (queryIndex < 0) {
          anythingElse = urlStr.slice(0, fragmentIndex);
          query = "";
        } else {
          anythingElse = urlStr.slice(0, queryIndex);
          query = urlStr.slice(queryIndex + 1, fragmentIndex);
        }
      }

      var queryParams = query.split("&").filter(function (q) {
        return q !== "" && !/^pipeline=/.test(q);
      });
      queryParams.push(queryParam);
      var result = anythingElse + "?" + queryParams.join("&");

      if (fragment !== "") {
        result += "#" + fragment;
      }

      return result;
    }
  }]);

  return ImageProcessingPipelineBuilder;
}();

function renderFormat(op) {
  return "format,".concat(op.format);
}

function renderQuality(op) {
  return "quality,Q_".concat(op.absoluteQuality);
}

function renderResize(op) {
  var parts = ["resize"];

  if (op.scalingMode != null) {
    parts.push("m_".concat(op.scalingMode));
  }

  if (op.longerSide != null) {
    parts.push("l_".concat(op.longerSide));
  }

  if (op.shorterSide != null) {
    parts.push("s_".concat(op.shorterSide));
  }

  if (op.targetWidth != null) {
    parts.push("w_".concat(op.targetWidth));
  }

  if (op.targetHeight != null) {
    parts.push("h_".concat(op.targetHeight));
  }

  if (op.color != null) {
    parts.push("color_".concat(op.color));
  }

  return parts.join(",");
}

/**
 * @public
 */

/**
 * @public
 */
var ValidationErrorKinds = {
  General: "General",
  Required: "Required",
  Type: "Type",
  Constant: "Constant",
  Enum: "Enum",
  ExtraEntry: "ExtraEntry",
  EntryAmount: "EntryAmount",
  StringLength: "StringLength",
  StringFormat: "StringFormat",
  NumberRange: "NumberRange"
};
/**
 * @public
 */

/**
 * Check if the provided error indicates the server failed to validate input
 * parameters to API.
 *
 * @remarks
 * The error may be thrown when calling any of the Skygear APIs.
 *
 * @public
 */
function isValidationError(err) {
  if (err instanceof SkygearError && err.reason === "ValidationFailed" && err.info != null && "causes" in err.info) {
    return true;
  }

  return false;
}

/**
 * @public
 */

var VERSION = "2.2.0" ;

/**
 * @public
 */

var WebAPIClient =
/*#__PURE__*/
function (_BaseAPIClient) {
  _inherits(WebAPIClient, _BaseAPIClient);

  function WebAPIClient() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, WebAPIClient);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WebAPIClient)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "fetchFunction", window.fetch.bind(window));

    _defineProperty(_assertThisInitialized(_this), "requestClass", Request);

    return _this;
  }

  return WebAPIClient;
}(BaseAPIClient);

var globalLocalStorage = localStorage;
/**
 * @public
 */

var localStorageStorageDriver = {
  get: function () {
    var _get = _asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee(key) {
      return regenerator.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", globalLocalStorage.getItem(key));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function get(_x) {
      return _get.apply(this, arguments);
    }

    return get;
  }(),
  set: function () {
    var _set = _asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee2(key, value) {
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", globalLocalStorage.setItem(key, value));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function set(_x2, _x3) {
      return _set.apply(this, arguments);
    }

    return set;
  }(),
  del: function () {
    var _del = _asyncToGenerator(
    /*#__PURE__*/
    regenerator.mark(function _callee3(key) {
      return regenerator.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", globalLocalStorage.removeItem(key));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function del(_x4) {
      return _del.apply(this, arguments);
    }

    return del;
  }()
};

var ErrNewWindowClosed = {};
var NewWindowObserver =
/*#__PURE__*/
function () {
  function NewWindowObserver() {
    _classCallCheck(this, NewWindowObserver);

    this.token = null;
  }

  _createClass(NewWindowObserver, [{
    key: "subscribe",
    value: function subscribe(newWindow) {
      var _this = this;

      this.unsubscribe();
      return new Promise(function (_, reject) {
        _this.token = window.setInterval(function () {
          if (newWindow.closed) {
            reject(ErrNewWindowClosed);
          }
        }, 1000);
      });
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      if (this.token) {
        window.clearInterval(this.token);
        this.token = null;
      }
    }
  }]);

  return NewWindowObserver;
}();
var WindowMessageObserver =
/*#__PURE__*/
function () {
  function WindowMessageObserver(origin) {
    _classCallCheck(this, WindowMessageObserver);

    this.origin = origin.replace(/\/$/, "");
    this.onMessage = null;
  }

  _createClass(WindowMessageObserver, [{
    key: "subscribe",
    value: function subscribe() {
      var _this2 = this;

      this.unsubscribe();
      return new Promise(function (resolve) {
        _this2.onMessage = function (event) {
          if (_this2.origin === event.origin) {
            resolve(event.data);

            _this2.unsubscribe();
          }
        };

        window.addEventListener("message", _this2.onMessage);
      });
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      if (this.onMessage) {
        window.removeEventListener("message", this.onMessage);
        this.onMessage = null;
      }
    }
  }]);

  return WindowMessageObserver;
}();

function byteToHex(_byte) {
  return ("0" + _byte.toString(16)).substr(-2);
} // uint8ArrayFrom is Uint8Array.from that works everywhere.


function uint8ArrayFrom(arr) {
  var output = new Uint8Array(arr.length);

  for (var i = 0; i < arr.length; ++i) {
    output[i] = arr[i];
  }

  return output;
} // windowCryptoSubtleDigest is window.crypto.subtle.digest with IE 11 support.


function windowCryptoSubtleDigest(algorithm, data) {
  var promiseOrEvent = window.crypto.subtle.digest(algorithm, data.buffer); // eslint-disable-next-line

  if (promiseOrEvent.then) {
    // @ts-ignore
    return promiseOrEvent.then(function (output) {
      return new Uint8Array(output);
    });
  }

  return new Promise(function (resolve, reject) {
    promiseOrEvent.oncomplete = function (output) {
      resolve(new Uint8Array(output));
    };

    promiseOrEvent.onerror = function (err) {
      reject(err);
    };
  });
}

function sha256(s) {
  var bytes = uint8ArrayFrom(_encodeUTF8(s));
  return windowCryptoSubtleDigest("SHA-256", bytes);
}

function computeCodeChallenge(_x) {
  return _computeCodeChallenge.apply(this, arguments);
}

function _computeCodeChallenge() {
  _computeCodeChallenge = _asyncToGenerator(
  /*#__PURE__*/
  regenerator.mark(function _callee(codeVerifier) {
    var hash, base64;
    return regenerator.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return sha256(codeVerifier);

          case 2:
            hash = _context.sent;
            base64 = _encodeBase64URLFromByteArray(hash);
            return _context.abrupt("return", base64);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _computeCodeChallenge.apply(this, arguments);
}

function generateCodeVerifier() {
  var arr = new Uint8Array(32);
  window.crypto.getRandomValues(arr);
  var output = "";

  for (var i = 0; i < arr.length; ++i) {
    output += byteToHex(arr[i]);
  }

  return output;
}

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function decodeMessage(message) {
  if (!message) {
    throw new Error("unknown message");
  }

  switch (message.type) {
    case "error":
      throw new Error(message.error);

    case "result":
      {
        var result = message.result;

        if (result.error) {
          throw decodeError(result.error);
        }

        return result.result;
      }

    case "end":
      throw new Error("Fail to retrive result");

    default:
      throw new Error("unknown message type: " + message.type);
  }
}

function uploadForm(url, req, blob, onUploadProgress) {
  var form = new FormData();

  if (req.prefix != null) {
    form.append("prefix", req.prefix);
  }

  if (req.access != null) {
    form.append("access", req.access);
  }

  if (req.headers != null) {
    for (var _i2 = 0, _Object$keys2 = Object.keys(req.headers); _i2 < _Object$keys2.length; _i2++) {
      var _name = _Object$keys2[_i2];
      var value = req.headers[_name];
      form.append(_name, value);
    }
  }

  form.append("file", blob, "filename");
  return new Promise(function (resolve, reject) {
    var xhr = new XMLHttpRequest();

    xhr.onload = function () {
      var jsonStr = xhr.responseText;

      try {
        var jsonBody = JSON.parse(jsonStr);

        if (jsonBody["result"]) {
          resolve(jsonBody["result"]["asset_name"]);
        } else if (jsonBody["error"]) {
          reject(decodeError(jsonBody["error"]));
        } else {
          reject(decodeError());
        }
      } catch (e) {
        reject(e);
      }
    };

    xhr.onerror = function () {
      reject(new TypeError("Network request failed"));
    };

    xhr.ontimeout = function () {
      reject(new TypeError("Network request failed"));
    };

    xhr.open("POST", url, true);

    if (xhr.upload != null) {
      xhr.upload.onprogress = function (e) {
        if (onUploadProgress != null) {
          onUploadProgress(e);
        }
      };
    }

    xhr.send(form);
  });
}
/**
 * Skygear Auth APIs (for web platforms).
 *
 * @public
 */


var WebAuthContainer =
/*#__PURE__*/
function (_AuthContainer) {
  _inherits(WebAuthContainer, _AuthContainer);

  function WebAuthContainer(parent) {
    var _this;

    _classCallCheck(this, WebAuthContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WebAuthContainer).call(this, parent));
    _this.oauthWindowObserver = null;
    _this.oauthResultObserver = null;
    return _this;
  }

  _createClass(WebAuthContainer, [{
    key: "_getAuthResultFromAuthorizationCode",
    value: function () {
      var _getAuthResultFromAuthorizationCode2 = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee(authorizationCode) {
        var codeVerifier, authRepsonse;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.parent.storage.getOAuthCodeVerifier(this.parent.name);

              case 2:
                codeVerifier = _context.sent;

                if (!(codeVerifier == null)) {
                  _context.next = 5;
                  break;
                }

                throw new Error("expected code verifier to exist");

              case 5:
                _context.next = 7;
                return this.parent.apiClient.getOAuthResult({
                  authorizationCode: authorizationCode,
                  codeVerifier: codeVerifier
                });

              case 7:
                authRepsonse = _context.sent;
                _context.next = 10;
                return this.parent.storage.delOAuthCodeVerifier(this.parent.name);

              case 10:
                return _context.abrupt("return", authRepsonse);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _getAuthResultFromAuthorizationCode(_x) {
        return _getAuthResultFromAuthorizationCode2.apply(this, arguments);
      }

      return _getAuthResultFromAuthorizationCode;
    }()
  }, {
    key: "_oauthProviderPopupFlow",
    value: function () {
      var _oauthProviderPopupFlow2 = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee2(providerID, action, options) {
        var newWindow, codeVerifier, codeChallenge, url, message;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                newWindow = window.open("", "_blank", "height=700,width=500");

                if (newWindow) {
                  _context2.next = 3;
                  break;
                }

                throw new Error("could not open new window");

              case 3:
                if (this.oauthWindowObserver == null) {
                  this.oauthWindowObserver = new NewWindowObserver();
                }

                if (this.oauthResultObserver == null) {
                  this.oauthResultObserver = new WindowMessageObserver(this.parent.apiClient.endpoint);
                }

                _context2.prev = 5;
                codeVerifier = generateCodeVerifier();
                _context2.next = 9;
                return computeCodeChallenge(codeVerifier);

              case 9:
                codeChallenge = _context2.sent;
                _context2.next = 12;
                return this.parent.storage.setOAuthCodeVerifier(this.parent.name, codeVerifier);

              case 12:
                _context2.next = 14;
                return this.parent.apiClient.oauthAuthorizationURL({
                  providerID: providerID,
                  codeChallenge: codeChallenge,
                  action: action,
                  uxMode: "web_popup",
                  onUserDuplicate: options && options.onUserDuplicate
                });

              case 14:
                url = _context2.sent;
                newWindow.location.href = url;
                _context2.next = 18;
                return Promise.race([this.oauthWindowObserver.subscribe(newWindow), this.oauthResultObserver.subscribe()]);

              case 18:
                message = _context2.sent;
                return _context2.abrupt("return", decodeMessage(message));

              case 20:
                _context2.prev = 20;
                newWindow.close(); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition

                if (this.oauthWindowObserver) {
                  this.oauthWindowObserver.unsubscribe();
                } // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition


                if (this.oauthResultObserver) {
                  this.oauthResultObserver.unsubscribe();
                }

                return _context2.finish(20);

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5,, 20, 25]]);
      }));

      function _oauthProviderPopupFlow(_x2, _x3, _x4) {
        return _oauthProviderPopupFlow2.apply(this, arguments);
      }

      return _oauthProviderPopupFlow;
    }()
    /**
     * Login user with OAuth SSO provider using popup window.
     *
     * @param providerID - SSO provider ID
     * @param options - SSO login options
     */

  }, {
    key: "loginOAuthProviderWithPopup",
    value: function () {
      var _loginOAuthProviderWithPopup = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee4(providerID, options) {
        var _this2 = this;

        var f;
        return regenerator.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                f =
                /*#__PURE__*/
                function () {
                  var _ref = _asyncToGenerator(
                  /*#__PURE__*/
                  regenerator.mark(function _callee3() {
                    var authorizationCode;
                    return regenerator.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return _this2._oauthProviderPopupFlow(providerID, "login", options);

                          case 2:
                            authorizationCode = _context3.sent;
                            return _context3.abrupt("return", _this2._getAuthResultFromAuthorizationCode(authorizationCode));

                          case 4:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function f() {
                    return _ref.apply(this, arguments);
                  };
                }();

                return _context4.abrupt("return", this.handleAuthResponse(f()));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function loginOAuthProviderWithPopup(_x5, _x6) {
        return _loginOAuthProviderWithPopup.apply(this, arguments);
      }

      return loginOAuthProviderWithPopup;
    }()
    /**
     * Links user with OAuth SSO provider using popup window.
     *
     * @param providerID - SSO provider ID
     */

  }, {
    key: "linkOAuthProviderWithPopup",
    value: function () {
      var _linkOAuthProviderWithPopup = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee6(providerID) {
        var _this3 = this;

        var f;
        return regenerator.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                f =
                /*#__PURE__*/
                function () {
                  var _ref2 = _asyncToGenerator(
                  /*#__PURE__*/
                  regenerator.mark(function _callee5() {
                    var authorizationCode;
                    return regenerator.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _context5.next = 2;
                            return _this3._oauthProviderPopupFlow(providerID, "link");

                          case 2:
                            authorizationCode = _context5.sent;
                            return _context5.abrupt("return", _this3._getAuthResultFromAuthorizationCode(authorizationCode));

                          case 4:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function f() {
                    return _ref2.apply(this, arguments);
                  };
                }();

                return _context6.abrupt("return", this.handleAuthResponse(f()));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function linkOAuthProviderWithPopup(_x7) {
        return _linkOAuthProviderWithPopup.apply(this, arguments);
      }

      return linkOAuthProviderWithPopup;
    }()
    /**
     * Login user with OAuth SSO provider by redirecting user.
     *
     * @param providerID - SSO provider ID
     * @param callbackURL - URL to return when authentication completed
     * @param options - SSO login options
     */

  }, {
    key: "loginOAuthProviderWithRedirect",
    value: function () {
      var _loginOAuthProviderWithRedirect = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee7(providerID, callbackURL, options) {
        var codeVerifier, codeChallenge, url;
        return regenerator.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                codeVerifier = generateCodeVerifier();
                _context7.next = 3;
                return computeCodeChallenge(codeVerifier);

              case 3:
                codeChallenge = _context7.sent;
                _context7.next = 6;
                return this.parent.storage.setOAuthCodeVerifier(this.parent.name, codeVerifier);

              case 6:
                _context7.next = 8;
                return this.parent.apiClient.oauthAuthorizationURL({
                  providerID: providerID,
                  codeChallenge: codeChallenge,
                  callbackURL: callbackURL,
                  action: "login",
                  uxMode: "web_redirect",
                  onUserDuplicate: options && options.onUserDuplicate
                });

              case 8:
                url = _context7.sent;
                _context7.next = 11;
                return this.parent.storage.setOAuthRedirectAction(this.parent.name, "login");

              case 11:
                window.location.href = url;

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function loginOAuthProviderWithRedirect(_x8, _x9, _x10) {
        return _loginOAuthProviderWithRedirect.apply(this, arguments);
      }

      return loginOAuthProviderWithRedirect;
    }()
    /**
     * Links user with OAuth SSO provider by redirecting user.
     *
     * @param providerID - SSO provider ID
     * @param callbackURL - URL to return when authentication completed
     */

  }, {
    key: "linkOAuthProviderWithRedirect",
    value: function () {
      var _linkOAuthProviderWithRedirect = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee8(providerID, callbackURL) {
        var codeVerifier, codeChallenge, url;
        return regenerator.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                codeVerifier = generateCodeVerifier();
                _context8.next = 3;
                return computeCodeChallenge(codeVerifier);

              case 3:
                codeChallenge = _context8.sent;
                _context8.next = 6;
                return this.parent.storage.setOAuthCodeVerifier(this.parent.name, codeVerifier);

              case 6:
                _context8.next = 8;
                return this.parent.apiClient.oauthAuthorizationURL({
                  providerID: providerID,
                  codeChallenge: codeChallenge,
                  callbackURL: callbackURL,
                  action: "link",
                  uxMode: "web_redirect"
                });

              case 8:
                url = _context8.sent;
                _context8.next = 11;
                return this.parent.storage.setOAuthRedirectAction(this.parent.name, "link");

              case 11:
                window.location.href = url;

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function linkOAuthProviderWithRedirect(_x11, _x12) {
        return _linkOAuthProviderWithRedirect.apply(this, arguments);
      }

      return linkOAuthProviderWithRedirect;
    }()
  }, {
    key: "_getRedirectResult",
    value: function () {
      var _getRedirectResult2 = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee9(action) {
        var lastAction, searchParams, result, jsonStr, j;
        return regenerator.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.parent.storage.getOAuthRedirectAction(this.parent.name);

              case 2:
                lastAction = _context9.sent;

                if (!(lastAction !== action)) {
                  _context9.next = 5;
                  break;
                }

                return _context9.abrupt("return", null);

              case 5:
                _context9.next = 7;
                return this.parent.storage.delOAuthRedirectAction(this.parent.name);

              case 7:
                searchParams = new URLSearchParams(window.location.search.slice(1));
                result = searchParams.get("x-skygear-result");

                if (!(result == null)) {
                  _context9.next = 11;
                  break;
                }

                return _context9.abrupt("return", null);

              case 11:
                jsonStr = atob(result);
                j = JSON.parse(jsonStr);

                if (!j.result.error) {
                  _context9.next = 15;
                  break;
                }

                throw decodeError(j.result.error);

              case 15:
                return _context9.abrupt("return", j.result.result);

              case 16:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function _getRedirectResult(_x13) {
        return _getRedirectResult2.apply(this, arguments);
      }

      return _getRedirectResult;
    }()
    /**
     * Gets SSO login result.
     *
     * @remarks
     * This function should be called by the page at `callbackURL`,
     * after calling {@link WebAuthContainer.loginOAuthProviderWithRedirect}.
     */

  }, {
    key: "getLoginRedirectResult",
    value: function () {
      var _getLoginRedirectResult = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee11() {
        var _this4 = this;

        var f;
        return regenerator.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                f =
                /*#__PURE__*/
                function () {
                  var _ref3 = _asyncToGenerator(
                  /*#__PURE__*/
                  regenerator.mark(function _callee10() {
                    var authorizationCode;
                    return regenerator.wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            _context10.next = 2;
                            return _this4._getRedirectResult("login");

                          case 2:
                            authorizationCode = _context10.sent;

                            if (authorizationCode) {
                              _context10.next = 5;
                              break;
                            }

                            return _context10.abrupt("return", null);

                          case 5:
                            return _context10.abrupt("return", _this4._getAuthResultFromAuthorizationCode(authorizationCode));

                          case 6:
                          case "end":
                            return _context10.stop();
                        }
                      }
                    }, _callee10);
                  }));

                  return function f() {
                    return _ref3.apply(this, arguments);
                  };
                }();

                return _context11.abrupt("return", this.handleMaybeAuthResponse(f()));

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getLoginRedirectResult() {
        return _getLoginRedirectResult.apply(this, arguments);
      }

      return getLoginRedirectResult;
    }()
    /**
     * Gets SSO link result.
     *
     * @remarks
     * This function should be called by the page at `callbackURL`,
     * after calling {@link WebAuthContainer.linkOAuthProviderWithRedirect}.
     */

  }, {
    key: "getLinkRedirectResult",
    value: function () {
      var _getLinkRedirectResult = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee13() {
        var _this5 = this;

        var f;
        return regenerator.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                f =
                /*#__PURE__*/
                function () {
                  var _ref4 = _asyncToGenerator(
                  /*#__PURE__*/
                  regenerator.mark(function _callee12() {
                    var authorizationCode;
                    return regenerator.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            _context12.next = 2;
                            return _this5._getRedirectResult("link");

                          case 2:
                            authorizationCode = _context12.sent;

                            if (authorizationCode) {
                              _context12.next = 5;
                              break;
                            }

                            return _context12.abrupt("return", null);

                          case 5:
                            return _context12.abrupt("return", _this5._getAuthResultFromAuthorizationCode(authorizationCode));

                          case 6:
                          case "end":
                            return _context12.stop();
                        }
                      }
                    }, _callee12);
                  }));

                  return function f() {
                    return _ref4.apply(this, arguments);
                  };
                }();

                return _context13.abrupt("return", this.handleMaybeAuthResponse(f()));

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getLinkRedirectResult() {
        return _getLinkRedirectResult.apply(this, arguments);
      }

      return getLinkRedirectResult;
    }()
  }]);

  return WebAuthContainer;
}(AuthContainer);
/**
 * @public
 */

/**
 * Skygear Asset APIs (for web platforms).
 *
 * @public
 */
var WebAssetContainer =
/*#__PURE__*/
function () {
  function WebAssetContainer(parent) {
    _classCallCheck(this, WebAssetContainer);

    this.parent = parent;
  }
  /**
   * Uploads new asset.
   *
   * @param blob - Asset data
   * @param options - Upload options
   *
   * @returns Asset name
   */


  _createClass(WebAssetContainer, [{
    key: "upload",
    value: function () {
      var _upload = _asyncToGenerator(
      /*#__PURE__*/
      regenerator.mark(function _callee14(blob, options) {
        var presignRequest, presignRequestHeaders, hasContentType, _i4, _Object$keys4, key, headerName, _ref5, url, asset_name;

        return regenerator.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                // Prepare presignRequest
                presignRequest = {};

                if (options != null) {
                  presignRequest.prefix = options.prefix;
                  presignRequest.access = options.access;

                  if (options.headers != null) {
                    presignRequest.headers = _objectSpread$3({}, options.headers);
                  }
                } // Prepare presignRequest.headers


                presignRequestHeaders = presignRequest.headers || {};
                hasContentType = false;
                _i4 = 0, _Object$keys4 = Object.keys(presignRequestHeaders);

              case 5:
                if (!(_i4 < _Object$keys4.length)) {
                  _context14.next = 17;
                  break;
                }

                key = _Object$keys4[_i4];
                headerName = key.toLowerCase();
                _context14.t0 = headerName;
                _context14.next = _context14.t0 === "content-type" ? 11 : 13;
                break;

              case 11:
                hasContentType = true;
                return _context14.abrupt("break", 14);

              case 13:
                return _context14.abrupt("break", 14);

              case 14:
                _i4++;
                _context14.next = 5;
                break;

              case 17:
                if (!hasContentType && blob.type !== "") {
                  presignRequestHeaders["content-type"] = String(blob.type);
                }

                presignRequest.headers = presignRequestHeaders;
                _context14.next = 21;
                return this.parent.apiClient._presignUploadForm();

              case 21:
                _ref5 = _context14.sent;
                url = _ref5.url;
                _context14.next = 25;
                return uploadForm(url, presignRequest, blob, options && options.onUploadProgress);

              case 25:
                asset_name = _context14.sent;
                return _context14.abrupt("return", asset_name);

              case 27:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function upload(_x14, _x15) {
        return _upload.apply(this, arguments);
      }

      return upload;
    }()
  }]);

  return WebAssetContainer;
}();
/**
 * Skygear APIs container (for web platforms).
 *
 * @public
 */

var WebContainer =
/*#__PURE__*/
function (_Container) {
  _inherits(WebContainer, _Container);

  function WebContainer(options) {
    var _this6;

    _classCallCheck(this, WebContainer);

    var o = _objectSpread$3({}, options, {
      apiClient: options && options.apiClient || new WebAPIClient(),
      storage: options && options.storage || new GlobalJSONContainerStorage(localStorageStorageDriver)
    });

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(WebContainer).call(this, o));
    _this6.auth = new WebAuthContainer(_assertThisInitialized(_this6));
    _this6.asset = new WebAssetContainer(_assertThisInitialized(_this6));
    return _this6;
  }

  return WebContainer;
}(Container);

/**
 * Default Skygear APIs container.
 *
 * @remarks
 * This is a global shared container, provided for convenience.
 *
 * @public
 */

var defaultContainer = new WebContainer();

export default defaultContainer;
export { AuthContainer, BaseAPIClient, Container, GlobalJSONContainerStorage, ImageProcessingPipelineBuilder, MFAContainer, SkygearError, SkygearErrorNames, VERSION, ValidationErrorKinds, WebAPIClient, WebAssetContainer, WebAuthContainer, WebContainer, _GlobalJSONStorage, _decodeExtraSessionInfoOptions, _encodeBase64FromString, _encodeBase64URLFromByteArray, _encodeExtraSessionInfoOptions, _encodeUTF8, _extractAuthenticationSession, _removeTrailingSlash, _windowAtob, decodeAuthResponse, decodeAuthenticator, decodeError, decodeIdentity, decodeSession, decodeUser, encodeIdentity, encodeQuery, encodeQueryComponent, encodeUser, generateOTPAuthURI, isMFARequiredError, isValidationError, localStorageStorageDriver };
